"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "individualAssistancePreliminaryDamageAssessmentForm", {
    enumerable: true,
    get: function() {
        return individualAssistancePreliminaryDamageAssessmentForm;
    }
});
const _authorization = require("../../../authorization");
const _constants = require("../../../constants");
const _constants1 = require("./constants");
const individualAssistancePreliminaryDamageAssessmentForm = {
    name: _constants1.IA_PDA_SUBMISSION_TYPE_NAME,
    modules: [
        _constants.SUBMISSION_TYPE_MODULE.PRELIMINARY_DAMAGE_ASSESSMENT
    ],
    attachments: [
        {
            type: _constants.OBJECT_TYPE.PROPERTY
        }
    ],
    successMessage: "Your PDA was saved",
    preamble: null,
    postamble: null,
    description: null,
    canCreate: _authorization.CREATOR_AND_UP,
    canCreateGroups: [],
    category: _constants.SUBMISSION_CATEGORY.INSPECTIONS,
    formStructure: {
        schema: {
            type: "object",
            required: [
                "assessmentDate",
                "primaryDamageType",
                "structureAccessible",
                "structureUse",
                "structureType",
                "damageDegree",
                "ownerType",
                "insurance"
            ],
            properties: {
                insurance: {
                    type: "string",
                    oneOf: [
                        {
                            const: "Yes",
                            title: "Yes"
                        },
                        {
                            const: "No",
                            title: "No"
                        },
                        {
                            const: "Unknown",
                            title: "Unknown"
                        }
                    ],
                    title: "Is there insurance?"
                },
                ownerType: {
                    type: "string",
                    oneOf: [
                        {
                            const: "Owner",
                            title: "Owner"
                        },
                        {
                            const: "Renter",
                            title: "Renter"
                        },
                        {
                            const: "Unknown",
                            title: "Unknown"
                        }
                    ],
                    title: "Owner or renter?"
                },
                description: {
                    type: [
                        "string",
                        "null"
                    ],
                    title: "Description"
                },
                damageDegree: {
                    enum: [
                        "None",
                        "Affected",
                        "Destroyed",
                        "Major",
                        "Minor",
                        "Unknown"
                    ],
                    type: "string",
                    title: "Degree of damage"
                },
                structureUse: {
                    type: "string",
                    oneOf: [
                        {
                            const: "Commercial",
                            title: "Commercial"
                        },
                        {
                            const: "Residential",
                            title: "Residential"
                        },
                        {
                            const: "Public",
                            title: "Public"
                        },
                        {
                            const: "Unknown",
                            title: "Unknown"
                        }
                    ],
                    title: "Structure use"
                },
                structureType: {
                    type: "string",
                    oneOf: [
                        {
                            const: "Conventional",
                            title: "Conventional"
                        },
                        {
                            const: "Manufactured",
                            title: "Manufactured"
                        },
                        {
                            const: "Mobile home",
                            title: "Mobile home"
                        },
                        {
                            const: "Non-standard",
                            title: "Non-standard"
                        },
                        {
                            const: "Unknown",
                            title: "Unknown"
                        }
                    ],
                    title: "Type of structure"
                },
                assessmentDate: {
                    type: "string",
                    title: "Date of assessment",
                    format: "date"
                },
                eventName: {
                    type: [
                        "array",
                        "null"
                    ],
                    items: {
                        type: "string",
                        oneOf: [
                            {
                                const: "Not Assigned",
                                title: "Not Assigned"
                            }
                        ]
                    },
                    title: "Event name",
                    minItems: 0,
                    description: "",
                    uniqueItems: true
                },
                depthOfFlooding: {
                    type: [
                        "number",
                        "null"
                    ],
                    title: "Depth of flooding (in inches)?"
                },
                documentUploads: {
                    type: [
                        "array",
                        "null"
                    ],
                    items: {
                        type: "object",
                        properties: {
                            id: {
                                type: [
                                    "string",
                                    "null"
                                ]
                            },
                            accountDocumentTypeId: {
                                enum: [
                                    _constants1.PROPERTY_IMAGE_ACCOUNT_DOCUMENT_TYPE_ID
                                ],
                                type: "string"
                            }
                        }
                    },
                    title: "Add photos",
                    maxItems: 10,
                    minItems: 0
                },
                structureFlooded: {
                    type: [
                        "string",
                        "null"
                    ],
                    oneOf: [
                        {
                            const: "Yes",
                            title: "Yes"
                        },
                        {
                            const: "No",
                            title: "No"
                        },
                        {
                            const: "Unknown",
                            title: "Unknown"
                        }
                    ],
                    title: "Is the structure flooded?"
                },
                primaryDamageType: {
                    type: "string",
                    oneOf: [
                        {
                            const: "Flooding",
                            title: "Flooding"
                        },
                        {
                            const: "Earthquake",
                            title: "Earthquake"
                        },
                        {
                            const: "Hail",
                            title: "Hail"
                        },
                        {
                            const: "Wind",
                            title: "Wind"
                        },
                        {
                            const: "Wildfire",
                            title: "Wildfire"
                        },
                        {
                            const: "Winter Weather/Ice Storm",
                            title: "Winter Weather/Ice Storm"
                        },
                        {
                            const: "Landslide",
                            title: "Landslide"
                        },
                        {
                            const: "Lightning",
                            title: "Lightning"
                        },
                        {
                            const: "Tornado",
                            title: "Tornado"
                        },
                        {
                            const: "Tsunami",
                            title: "Tsunami"
                        },
                        {
                            const: "Volcanic Activity",
                            title: "Volcanic Activity"
                        }
                    ],
                    title: "Primary type of damage"
                },
                tertiaryDamageType: {
                    type: [
                        "string",
                        "null"
                    ],
                    oneOf: [
                        {
                            const: "Flooding",
                            title: "Flooding"
                        },
                        {
                            const: "Earthquake",
                            title: "Earthquake"
                        },
                        {
                            const: "Hail",
                            title: "Hail"
                        },
                        {
                            const: "Wind",
                            title: "Wind"
                        },
                        {
                            const: "Wildfire",
                            title: "Wildfire"
                        },
                        {
                            const: "Winter Weather/Ice Storm",
                            title: "Winter Weather/Ice Storm"
                        },
                        {
                            const: "Landslide",
                            title: "Landslide"
                        },
                        {
                            const: "Lightning",
                            title: "Lightning"
                        },
                        {
                            const: "Tornado",
                            title: "Tornado"
                        },
                        {
                            const: "Tsunami",
                            title: "Tsunami"
                        },
                        {
                            const: "Volcanic Activity",
                            title: "Volcanic Activity"
                        }
                    ],
                    title: "Tertiary type of damage"
                },
                secondaryDamageType: {
                    type: [
                        "string",
                        "null"
                    ],
                    oneOf: [
                        {
                            const: "Flooding",
                            title: "Flooding"
                        },
                        {
                            const: "Earthquake",
                            title: "Earthquake"
                        },
                        {
                            const: "Hail",
                            title: "Hail"
                        },
                        {
                            const: "Wind",
                            title: "Wind"
                        },
                        {
                            const: "Wildfire",
                            title: "Wildfire"
                        },
                        {
                            const: "Winter Weather/Ice Storm",
                            title: "Winter Weather/Ice Storm"
                        },
                        {
                            const: "Landslide",
                            title: "Landslide"
                        },
                        {
                            const: "Lightning",
                            title: "Lightning"
                        },
                        {
                            const: "Tornado",
                            title: "Tornado"
                        },
                        {
                            const: "Tsunami",
                            title: "Tsunami"
                        },
                        {
                            const: "Volcanic Activity",
                            title: "Volcanic Activity"
                        }
                    ],
                    title: "Secondary type of damage"
                },
                structureAccessible: {
                    type: "string",
                    oneOf: [
                        {
                            const: "Yes",
                            title: "Yes"
                        },
                        {
                            const: "No",
                            title: "No"
                        },
                        {
                            const: "Unknown",
                            title: "Unknown"
                        }
                    ],
                    title: "Is the structure accessible?"
                },
                residenceType: {
                    type: [
                        "string",
                        "null"
                    ],
                    oneOf: [
                        {
                            const: "Primary residence",
                            title: "Primary residence"
                        },
                        {
                            const: "Secondary residence",
                            title: "Secondary residence"
                        }
                    ],
                    title: "Residence type"
                }
            }
        },
        uiSchema: {
            "ui:order": [
                "assessmentDate",
                "eventName",
                "primaryDamageType",
                "secondaryDamageType",
                "tertiaryDamageType",
                "structureAccessible",
                "structureUse",
                "structureType",
                "damageDegree",
                "ownerType",
                "residenceType",
                "insurance",
                "structureFlooded",
                "depthOfFlooding",
                "description",
                "documentUploads"
            ],
            "ui:hideError": true,
            insurance: {
                oneOf: [
                    {
                        const: "Yes",
                        title: "Yes"
                    },
                    {
                        const: "No",
                        title: "No"
                    },
                    {
                        const: "Unknown",
                        title: "Unknown"
                    }
                ],
                "ui:label": false,
                "ui:widget": "select",
                "ui:placeholder": "Select...",
                "ui:canUpdate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ],
                "ui:viewOnRetrieve": [
                    "admin",
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "guest"
                ],
                "ui:viewOnCreate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ]
            },
            ownerType: {
                oneOf: [
                    {
                        const: "Owner",
                        title: "Owner"
                    },
                    {
                        const: "Renter",
                        title: "Renter"
                    },
                    {
                        const: "Unknown",
                        title: "Unknown"
                    }
                ],
                "ui:label": false,
                "ui:widget": "select",
                "ui:placeholder": "Select...",
                "ui:canUpdate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ],
                "ui:viewOnRetrieve": [
                    "admin",
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "guest"
                ],
                "ui:viewOnCreate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ]
            },
            description: {
                "ui:label": false,
                "ui:widget": "textarea",
                "ui:placeholder": "",
                "ui:canUpdate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ],
                "ui:viewOnRetrieve": [
                    "admin",
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "guest"
                ],
                "ui:viewOnCreate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ]
            },
            damageDegree: {
                "ui:label": false,
                "ui:widget": "DamageDegree",
                "ui:placeholder": "Select...",
                "ui:canUpdate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ],
                "ui:viewOnRetrieve": [
                    "admin",
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "guest"
                ],
                "ui:viewOnCreate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ]
            },
            structureUse: {
                oneOf: [
                    {
                        const: "Commercial",
                        title: "Commercial"
                    },
                    {
                        const: "Residential",
                        title: "Residential"
                    },
                    {
                        const: "Public",
                        title: "Public"
                    },
                    {
                        const: "Unknown",
                        title: "Unknown"
                    }
                ],
                "ui:label": false,
                "ui:widget": "select",
                "ui:placeholder": "Select...",
                "ui:canUpdate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ],
                "ui:viewOnRetrieve": [
                    "admin",
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "guest"
                ],
                "ui:viewOnCreate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ]
            },
            structureType: {
                oneOf: [
                    {
                        const: "Conventional",
                        title: "Conventional"
                    },
                    {
                        const: "Manufactured",
                        title: "Manufactured"
                    },
                    {
                        const: "Mobile home",
                        title: "Mobile home"
                    },
                    {
                        const: "Non-standard",
                        title: "Non-standard"
                    },
                    {
                        const: "Unknown",
                        title: "Unknown"
                    }
                ],
                "ui:label": false,
                "ui:widget": "select",
                "ui:placeholder": "Select...",
                "ui:canUpdate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ],
                "ui:viewOnRetrieve": [
                    "admin",
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "guest"
                ],
                "ui:viewOnCreate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ]
            },
            assessmentDate: {
                "ui:label": false,
                "ui:widget": "date",
                "ui:defaultToToday": true,
                "ui:canUpdate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ],
                "ui:viewOnRetrieve": [
                    "admin",
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "guest"
                ],
                "ui:viewOnCreate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ]
            },
            eventName: {
                "ui:field": "multiSelect",
                "ui:label": false,
                "ui:canUpdate": [
                    "creator",
                    "member",
                    "manager",
                    "admin"
                ],
                "ui:description": "",
                "ui:tooltipText": "",
                "ui:viewOnCreate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ],
                "ui:viewOnRetrieve": [
                    "view_only",
                    "creator",
                    "member",
                    "manager",
                    "admin"
                ]
            },
            depthOfFlooding: {
                "ui:step": 0.5,
                "ui:field": "number",
                "ui:label": false,
                "ui:canUpdate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ],
                "ui:viewOnRetrieve": [
                    "admin",
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "guest"
                ],
                "ui:viewOnCreate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ]
            },
            documentUploads: {
                "ui:field": "DocumentUploader",
                "ui:label": false,
                "ui:documentTypeName": "images",
                "ui:fileSizeDescription": "The size limit for each individual file is 30 MB. Please reduce the file size of your images before uploading if they exceed this limit.",
                "ui:fileTypeDescription": "We only allow JPEG and PNG uploads at this time. If you have an image with another file type, please convert it to JPEG or PNG before uploading.",
                "ui:fileQuantityDescription": "You can upload as many as 10 images. If you have additional property images, please start a new inspection or upload to the property.",
                "ui:documentTypeAbbreviation": "image",
                "ui:canUpdate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ],
                "ui:viewOnRetrieve": [
                    "admin",
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "guest"
                ],
                "ui:viewOnCreate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ]
            },
            structureFlooded: {
                oneOf: [
                    {
                        const: "Yes",
                        title: "Yes"
                    },
                    {
                        const: "No",
                        title: "No"
                    },
                    {
                        const: "Unknown",
                        title: "Unknown"
                    }
                ],
                "ui:label": false,
                "ui:widget": "select",
                "ui:placeholder": "Select...",
                "ui:canUpdate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ],
                "ui:viewOnRetrieve": [
                    "admin",
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "guest"
                ],
                "ui:viewOnCreate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ]
            },
            primaryDamageType: {
                oneOf: [
                    {
                        const: "Flooding",
                        title: "Flooding"
                    },
                    {
                        const: "Earthquake",
                        title: "Earthquake"
                    },
                    {
                        const: "Hail",
                        title: "Hail"
                    },
                    {
                        const: "Wind",
                        title: "Wind"
                    },
                    {
                        const: "Wildfire",
                        title: "Wildfire"
                    },
                    {
                        const: "Winter Weather/Ice Storm",
                        title: "Winter Weather/Ice Storm"
                    },
                    {
                        const: "Landslide",
                        title: "Landslide"
                    },
                    {
                        const: "Lightning",
                        title: "Lightning"
                    },
                    {
                        const: "Tornado",
                        title: "Tornado"
                    },
                    {
                        const: "Tsunami",
                        title: "Tsunami"
                    },
                    {
                        const: "Volcanic Activity",
                        title: "Volcanic Activity"
                    }
                ],
                "ui:label": false,
                "ui:widget": "select",
                "ui:placeholder": "Select...",
                "ui:canUpdate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ],
                "ui:viewOnRetrieve": [
                    "admin",
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "guest"
                ],
                "ui:viewOnCreate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ]
            },
            tertiaryDamageType: {
                oneOf: [
                    {
                        const: "Flooding",
                        title: "Flooding"
                    },
                    {
                        const: "Earthquake",
                        title: "Earthquake"
                    },
                    {
                        const: "Hail",
                        title: "Hail"
                    },
                    {
                        const: "Wind",
                        title: "Wind"
                    },
                    {
                        const: "Wildfire",
                        title: "Wildfire"
                    },
                    {
                        const: "Winter Weather/Ice Storm",
                        title: "Winter Weather/Ice Storm"
                    },
                    {
                        const: "Landslide",
                        title: "Landslide"
                    },
                    {
                        const: "Lightning",
                        title: "Lightning"
                    },
                    {
                        const: "Tornado",
                        title: "Tornado"
                    },
                    {
                        const: "Tsunami",
                        title: "Tsunami"
                    },
                    {
                        const: "Volcanic Activity",
                        title: "Volcanic Activity"
                    }
                ],
                "ui:label": false,
                "ui:widget": "select",
                "ui:placeholder": "Select...",
                "ui:canUpdate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ],
                "ui:viewOnRetrieve": [
                    "admin",
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "guest"
                ],
                "ui:viewOnCreate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ]
            },
            secondaryDamageType: {
                oneOf: [
                    {
                        const: "Flooding",
                        title: "Flooding"
                    },
                    {
                        const: "Earthquake",
                        title: "Earthquake"
                    },
                    {
                        const: "Hail",
                        title: "Hail"
                    },
                    {
                        const: "Wind",
                        title: "Wind"
                    },
                    {
                        const: "Wildfire",
                        title: "Wildfire"
                    },
                    {
                        const: "Winter Weather/Ice Storm",
                        title: "Winter Weather/Ice Storm"
                    },
                    {
                        const: "Landslide",
                        title: "Landslide"
                    },
                    {
                        const: "Lightning",
                        title: "Lightning"
                    },
                    {
                        const: "Tornado",
                        title: "Tornado"
                    },
                    {
                        const: "Tsunami",
                        title: "Tsunami"
                    },
                    {
                        const: "Volcanic Activity",
                        title: "Volcanic Activity"
                    }
                ],
                "ui:label": false,
                "ui:widget": "select",
                "ui:placeholder": "Select...",
                "ui:canUpdate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ],
                "ui:viewOnRetrieve": [
                    "admin",
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "guest"
                ],
                "ui:viewOnCreate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ]
            },
            structureAccessible: {
                oneOf: [
                    {
                        const: "Yes",
                        title: "Yes"
                    },
                    {
                        const: "No",
                        title: "No"
                    },
                    {
                        const: "Unknown",
                        title: "Unknown"
                    }
                ],
                "ui:label": false,
                "ui:widget": "select",
                "ui:placeholder": "Select...",
                "ui:canUpdate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ],
                "ui:viewOnRetrieve": [
                    "admin",
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "guest"
                ],
                "ui:viewOnCreate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ]
            },
            residenceType: {
                oneOf: [
                    {
                        const: "Primary residence",
                        title: "Primary residence"
                    },
                    {
                        const: "Secondary residence",
                        title: "Secondary residence"
                    }
                ],
                "ui:label": false,
                "ui:widget": "select",
                "ui:useAsTag": false,
                "ui:canUpdate": [
                    "creator",
                    "member",
                    "manager",
                    "admin"
                ],
                "ui:helperText": "",
                "ui:placeholder": "",
                "ui:tooltipText": "",
                "ui:viewOnCreate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ],
                "ui:viewOnRetrieve": [
                    "view_only",
                    "creator",
                    "member",
                    "manager",
                    "admin"
                ]
            }
        }
    }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NlcnZpY2VzL2Zvcm1CdWlsZGVyU2VydmljZS9jb21tb25Gb3Jtcy9pbmRpdmlkdWFsQXNzaXN0YW5jZVByZWxpbWluYXJ5RGFtYWdlQXNzZXNzbWVudC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBDUkVBVE9SX0FORF9VUCB9IGZyb20gXCIuLi8uLi8uLi9hdXRob3JpemF0aW9uXCI7XG5pbXBvcnQge1xuICBPQkpFQ1RfVFlQRSxcbiAgU1VCTUlTU0lPTl9DQVRFR09SWSxcbiAgU1VCTUlTU0lPTl9UWVBFX01PRFVMRSxcbn0gZnJvbSBcIi4uLy4uLy4uL2NvbnN0YW50c1wiO1xuaW1wb3J0IHtcbiAgSUFfUERBX1NVQk1JU1NJT05fVFlQRV9OQU1FLFxuICBQUk9QRVJUWV9JTUFHRV9BQ0NPVU5UX0RPQ1VNRU5UX1RZUEVfSUQsXG59IGZyb20gXCIuL2NvbnN0YW50c1wiO1xuaW1wb3J0IHsgQ29tbW9uRm9ybURlZmluaXRpb24gfSBmcm9tIFwiLi90eXBlc1wiO1xuXG5leHBvcnQgY29uc3QgaW5kaXZpZHVhbEFzc2lzdGFuY2VQcmVsaW1pbmFyeURhbWFnZUFzc2Vzc21lbnRGb3JtID0ge1xuICBuYW1lOiBJQV9QREFfU1VCTUlTU0lPTl9UWVBFX05BTUUsXG4gIG1vZHVsZXM6IFtTVUJNSVNTSU9OX1RZUEVfTU9EVUxFLlBSRUxJTUlOQVJZX0RBTUFHRV9BU1NFU1NNRU5UXSxcbiAgYXR0YWNobWVudHM6IFt7IHR5cGU6IE9CSkVDVF9UWVBFLlBST1BFUlRZIH1dLFxuICBzdWNjZXNzTWVzc2FnZTogXCJZb3VyIFBEQSB3YXMgc2F2ZWRcIixcbiAgcHJlYW1ibGU6IG51bGwsXG4gIHBvc3RhbWJsZTogbnVsbCxcbiAgZGVzY3JpcHRpb246IG51bGwsXG4gIGNhbkNyZWF0ZTogQ1JFQVRPUl9BTkRfVVAsXG4gIGNhbkNyZWF0ZUdyb3VwczogW10sXG4gIGNhdGVnb3J5OiBTVUJNSVNTSU9OX0NBVEVHT1JZLklOU1BFQ1RJT05TLFxuICBmb3JtU3RydWN0dXJlOiB7XG4gICAgc2NoZW1hOiB7XG4gICAgICB0eXBlOiBcIm9iamVjdFwiLFxuICAgICAgcmVxdWlyZWQ6IFtcbiAgICAgICAgXCJhc3Nlc3NtZW50RGF0ZVwiLFxuICAgICAgICBcInByaW1hcnlEYW1hZ2VUeXBlXCIsXG4gICAgICAgIFwic3RydWN0dXJlQWNjZXNzaWJsZVwiLFxuICAgICAgICBcInN0cnVjdHVyZVVzZVwiLFxuICAgICAgICBcInN0cnVjdHVyZVR5cGVcIixcbiAgICAgICAgXCJkYW1hZ2VEZWdyZWVcIixcbiAgICAgICAgXCJvd25lclR5cGVcIixcbiAgICAgICAgXCJpbnN1cmFuY2VcIixcbiAgICAgIF0sXG4gICAgICBwcm9wZXJ0aWVzOiB7XG4gICAgICAgIGluc3VyYW5jZToge1xuICAgICAgICAgIHR5cGU6IFwic3RyaW5nXCIsXG4gICAgICAgICAgb25lT2Y6IFtcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiWWVzXCIsIHRpdGxlOiBcIlllc1wiIH0sXG4gICAgICAgICAgICB7IGNvbnN0OiBcIk5vXCIsIHRpdGxlOiBcIk5vXCIgfSxcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiVW5rbm93blwiLCB0aXRsZTogXCJVbmtub3duXCIgfSxcbiAgICAgICAgICBdLFxuICAgICAgICAgIHRpdGxlOiBcIklzIHRoZXJlIGluc3VyYW5jZT9cIixcbiAgICAgICAgfSxcbiAgICAgICAgb3duZXJUeXBlOiB7XG4gICAgICAgICAgdHlwZTogXCJzdHJpbmdcIixcbiAgICAgICAgICBvbmVPZjogW1xuICAgICAgICAgICAgeyBjb25zdDogXCJPd25lclwiLCB0aXRsZTogXCJPd25lclwiIH0sXG4gICAgICAgICAgICB7IGNvbnN0OiBcIlJlbnRlclwiLCB0aXRsZTogXCJSZW50ZXJcIiB9LFxuICAgICAgICAgICAgeyBjb25zdDogXCJVbmtub3duXCIsIHRpdGxlOiBcIlVua25vd25cIiB9LFxuICAgICAgICAgIF0sXG4gICAgICAgICAgdGl0bGU6IFwiT3duZXIgb3IgcmVudGVyP1wiLFxuICAgICAgICB9LFxuICAgICAgICBkZXNjcmlwdGlvbjogeyB0eXBlOiBbXCJzdHJpbmdcIiwgXCJudWxsXCJdLCB0aXRsZTogXCJEZXNjcmlwdGlvblwiIH0sXG4gICAgICAgIGRhbWFnZURlZ3JlZToge1xuICAgICAgICAgIGVudW06IFtcIk5vbmVcIiwgXCJBZmZlY3RlZFwiLCBcIkRlc3Ryb3llZFwiLCBcIk1ham9yXCIsIFwiTWlub3JcIiwgXCJVbmtub3duXCJdLFxuICAgICAgICAgIHR5cGU6IFwic3RyaW5nXCIsXG4gICAgICAgICAgdGl0bGU6IFwiRGVncmVlIG9mIGRhbWFnZVwiLFxuICAgICAgICB9LFxuICAgICAgICBzdHJ1Y3R1cmVVc2U6IHtcbiAgICAgICAgICB0eXBlOiBcInN0cmluZ1wiLFxuICAgICAgICAgIG9uZU9mOiBbXG4gICAgICAgICAgICB7IGNvbnN0OiBcIkNvbW1lcmNpYWxcIiwgdGl0bGU6IFwiQ29tbWVyY2lhbFwiIH0sXG4gICAgICAgICAgICB7IGNvbnN0OiBcIlJlc2lkZW50aWFsXCIsIHRpdGxlOiBcIlJlc2lkZW50aWFsXCIgfSxcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiUHVibGljXCIsIHRpdGxlOiBcIlB1YmxpY1wiIH0sXG4gICAgICAgICAgICB7IGNvbnN0OiBcIlVua25vd25cIiwgdGl0bGU6IFwiVW5rbm93blwiIH0sXG4gICAgICAgICAgXSxcbiAgICAgICAgICB0aXRsZTogXCJTdHJ1Y3R1cmUgdXNlXCIsXG4gICAgICAgIH0sXG4gICAgICAgIHN0cnVjdHVyZVR5cGU6IHtcbiAgICAgICAgICB0eXBlOiBcInN0cmluZ1wiLFxuICAgICAgICAgIG9uZU9mOiBbXG4gICAgICAgICAgICB7IGNvbnN0OiBcIkNvbnZlbnRpb25hbFwiLCB0aXRsZTogXCJDb252ZW50aW9uYWxcIiB9LFxuICAgICAgICAgICAgeyBjb25zdDogXCJNYW51ZmFjdHVyZWRcIiwgdGl0bGU6IFwiTWFudWZhY3R1cmVkXCIgfSxcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiTW9iaWxlIGhvbWVcIiwgdGl0bGU6IFwiTW9iaWxlIGhvbWVcIiB9LFxuICAgICAgICAgICAgeyBjb25zdDogXCJOb24tc3RhbmRhcmRcIiwgdGl0bGU6IFwiTm9uLXN0YW5kYXJkXCIgfSxcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiVW5rbm93blwiLCB0aXRsZTogXCJVbmtub3duXCIgfSxcbiAgICAgICAgICBdLFxuICAgICAgICAgIHRpdGxlOiBcIlR5cGUgb2Ygc3RydWN0dXJlXCIsXG4gICAgICAgIH0sXG4gICAgICAgIGFzc2Vzc21lbnREYXRlOiB7XG4gICAgICAgICAgdHlwZTogXCJzdHJpbmdcIixcbiAgICAgICAgICB0aXRsZTogXCJEYXRlIG9mIGFzc2Vzc21lbnRcIixcbiAgICAgICAgICBmb3JtYXQ6IFwiZGF0ZVwiLFxuICAgICAgICB9LFxuICAgICAgICBldmVudE5hbWU6IHtcbiAgICAgICAgICB0eXBlOiBbXCJhcnJheVwiLCBcIm51bGxcIl0sXG4gICAgICAgICAgaXRlbXM6IHtcbiAgICAgICAgICAgIHR5cGU6IFwic3RyaW5nXCIsXG4gICAgICAgICAgICBvbmVPZjogW3sgY29uc3Q6IFwiTm90IEFzc2lnbmVkXCIsIHRpdGxlOiBcIk5vdCBBc3NpZ25lZFwiIH1dLFxuICAgICAgICAgIH0sXG4gICAgICAgICAgdGl0bGU6IFwiRXZlbnQgbmFtZVwiLFxuICAgICAgICAgIG1pbkl0ZW1zOiAwLFxuICAgICAgICAgIGRlc2NyaXB0aW9uOiBcIlwiLFxuICAgICAgICAgIHVuaXF1ZUl0ZW1zOiB0cnVlLFxuICAgICAgICB9LFxuICAgICAgICBkZXB0aE9mRmxvb2Rpbmc6IHtcbiAgICAgICAgICB0eXBlOiBbXCJudW1iZXJcIiwgXCJudWxsXCJdLFxuICAgICAgICAgIHRpdGxlOiBcIkRlcHRoIG9mIGZsb29kaW5nIChpbiBpbmNoZXMpP1wiLFxuICAgICAgICB9LFxuICAgICAgICBkb2N1bWVudFVwbG9hZHM6IHtcbiAgICAgICAgICB0eXBlOiBbXCJhcnJheVwiLCBcIm51bGxcIl0sXG4gICAgICAgICAgaXRlbXM6IHtcbiAgICAgICAgICAgIHR5cGU6IFwib2JqZWN0XCIsXG4gICAgICAgICAgICBwcm9wZXJ0aWVzOiB7XG4gICAgICAgICAgICAgIGlkOiB7IHR5cGU6IFtcInN0cmluZ1wiLCBcIm51bGxcIl0gfSxcbiAgICAgICAgICAgICAgYWNjb3VudERvY3VtZW50VHlwZUlkOiB7XG4gICAgICAgICAgICAgICAgZW51bTogW1BST1BFUlRZX0lNQUdFX0FDQ09VTlRfRE9DVU1FTlRfVFlQRV9JRF0sXG4gICAgICAgICAgICAgICAgdHlwZTogXCJzdHJpbmdcIixcbiAgICAgICAgICAgICAgfSxcbiAgICAgICAgICAgIH0sXG4gICAgICAgICAgfSxcbiAgICAgICAgICB0aXRsZTogXCJBZGQgcGhvdG9zXCIsXG4gICAgICAgICAgbWF4SXRlbXM6IDEwLFxuICAgICAgICAgIG1pbkl0ZW1zOiAwLFxuICAgICAgICB9LFxuICAgICAgICBzdHJ1Y3R1cmVGbG9vZGVkOiB7XG4gICAgICAgICAgdHlwZTogW1wic3RyaW5nXCIsIFwibnVsbFwiXSxcbiAgICAgICAgICBvbmVPZjogW1xuICAgICAgICAgICAgeyBjb25zdDogXCJZZXNcIiwgdGl0bGU6IFwiWWVzXCIgfSxcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiTm9cIiwgdGl0bGU6IFwiTm9cIiB9LFxuICAgICAgICAgICAgeyBjb25zdDogXCJVbmtub3duXCIsIHRpdGxlOiBcIlVua25vd25cIiB9LFxuICAgICAgICAgIF0sXG4gICAgICAgICAgdGl0bGU6IFwiSXMgdGhlIHN0cnVjdHVyZSBmbG9vZGVkP1wiLFxuICAgICAgICB9LFxuICAgICAgICBwcmltYXJ5RGFtYWdlVHlwZToge1xuICAgICAgICAgIHR5cGU6IFwic3RyaW5nXCIsXG4gICAgICAgICAgb25lT2Y6IFtcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiRmxvb2RpbmdcIiwgdGl0bGU6IFwiRmxvb2RpbmdcIiB9LFxuICAgICAgICAgICAgeyBjb25zdDogXCJFYXJ0aHF1YWtlXCIsIHRpdGxlOiBcIkVhcnRocXVha2VcIiB9LFxuICAgICAgICAgICAgeyBjb25zdDogXCJIYWlsXCIsIHRpdGxlOiBcIkhhaWxcIiB9LFxuICAgICAgICAgICAgeyBjb25zdDogXCJXaW5kXCIsIHRpdGxlOiBcIldpbmRcIiB9LFxuICAgICAgICAgICAgeyBjb25zdDogXCJXaWxkZmlyZVwiLCB0aXRsZTogXCJXaWxkZmlyZVwiIH0sXG4gICAgICAgICAgICB7XG4gICAgICAgICAgICAgIGNvbnN0OiBcIldpbnRlciBXZWF0aGVyL0ljZSBTdG9ybVwiLFxuICAgICAgICAgICAgICB0aXRsZTogXCJXaW50ZXIgV2VhdGhlci9JY2UgU3Rvcm1cIixcbiAgICAgICAgICAgIH0sXG4gICAgICAgICAgICB7IGNvbnN0OiBcIkxhbmRzbGlkZVwiLCB0aXRsZTogXCJMYW5kc2xpZGVcIiB9LFxuICAgICAgICAgICAgeyBjb25zdDogXCJMaWdodG5pbmdcIiwgdGl0bGU6IFwiTGlnaHRuaW5nXCIgfSxcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiVG9ybmFkb1wiLCB0aXRsZTogXCJUb3JuYWRvXCIgfSxcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiVHN1bmFtaVwiLCB0aXRsZTogXCJUc3VuYW1pXCIgfSxcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiVm9sY2FuaWMgQWN0aXZpdHlcIiwgdGl0bGU6IFwiVm9sY2FuaWMgQWN0aXZpdHlcIiB9LFxuICAgICAgICAgIF0sXG4gICAgICAgICAgdGl0bGU6IFwiUHJpbWFyeSB0eXBlIG9mIGRhbWFnZVwiLFxuICAgICAgICB9LFxuICAgICAgICB0ZXJ0aWFyeURhbWFnZVR5cGU6IHtcbiAgICAgICAgICB0eXBlOiBbXCJzdHJpbmdcIiwgXCJudWxsXCJdLFxuICAgICAgICAgIG9uZU9mOiBbXG4gICAgICAgICAgICB7IGNvbnN0OiBcIkZsb29kaW5nXCIsIHRpdGxlOiBcIkZsb29kaW5nXCIgfSxcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiRWFydGhxdWFrZVwiLCB0aXRsZTogXCJFYXJ0aHF1YWtlXCIgfSxcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiSGFpbFwiLCB0aXRsZTogXCJIYWlsXCIgfSxcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiV2luZFwiLCB0aXRsZTogXCJXaW5kXCIgfSxcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiV2lsZGZpcmVcIiwgdGl0bGU6IFwiV2lsZGZpcmVcIiB9LFxuICAgICAgICAgICAge1xuICAgICAgICAgICAgICBjb25zdDogXCJXaW50ZXIgV2VhdGhlci9JY2UgU3Rvcm1cIixcbiAgICAgICAgICAgICAgdGl0bGU6IFwiV2ludGVyIFdlYXRoZXIvSWNlIFN0b3JtXCIsXG4gICAgICAgICAgICB9LFxuICAgICAgICAgICAgeyBjb25zdDogXCJMYW5kc2xpZGVcIiwgdGl0bGU6IFwiTGFuZHNsaWRlXCIgfSxcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiTGlnaHRuaW5nXCIsIHRpdGxlOiBcIkxpZ2h0bmluZ1wiIH0sXG4gICAgICAgICAgICB7IGNvbnN0OiBcIlRvcm5hZG9cIiwgdGl0bGU6IFwiVG9ybmFkb1wiIH0sXG4gICAgICAgICAgICB7IGNvbnN0OiBcIlRzdW5hbWlcIiwgdGl0bGU6IFwiVHN1bmFtaVwiIH0sXG4gICAgICAgICAgICB7IGNvbnN0OiBcIlZvbGNhbmljIEFjdGl2aXR5XCIsIHRpdGxlOiBcIlZvbGNhbmljIEFjdGl2aXR5XCIgfSxcbiAgICAgICAgICBdLFxuICAgICAgICAgIHRpdGxlOiBcIlRlcnRpYXJ5IHR5cGUgb2YgZGFtYWdlXCIsXG4gICAgICAgIH0sXG4gICAgICAgIHNlY29uZGFyeURhbWFnZVR5cGU6IHtcbiAgICAgICAgICB0eXBlOiBbXCJzdHJpbmdcIiwgXCJudWxsXCJdLFxuICAgICAgICAgIG9uZU9mOiBbXG4gICAgICAgICAgICB7IGNvbnN0OiBcIkZsb29kaW5nXCIsIHRpdGxlOiBcIkZsb29kaW5nXCIgfSxcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiRWFydGhxdWFrZVwiLCB0aXRsZTogXCJFYXJ0aHF1YWtlXCIgfSxcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiSGFpbFwiLCB0aXRsZTogXCJIYWlsXCIgfSxcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiV2luZFwiLCB0aXRsZTogXCJXaW5kXCIgfSxcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiV2lsZGZpcmVcIiwgdGl0bGU6IFwiV2lsZGZpcmVcIiB9LFxuICAgICAgICAgICAge1xuICAgICAgICAgICAgICBjb25zdDogXCJXaW50ZXIgV2VhdGhlci9JY2UgU3Rvcm1cIixcbiAgICAgICAgICAgICAgdGl0bGU6IFwiV2ludGVyIFdlYXRoZXIvSWNlIFN0b3JtXCIsXG4gICAgICAgICAgICB9LFxuICAgICAgICAgICAgeyBjb25zdDogXCJMYW5kc2xpZGVcIiwgdGl0bGU6IFwiTGFuZHNsaWRlXCIgfSxcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiTGlnaHRuaW5nXCIsIHRpdGxlOiBcIkxpZ2h0bmluZ1wiIH0sXG4gICAgICAgICAgICB7IGNvbnN0OiBcIlRvcm5hZG9cIiwgdGl0bGU6IFwiVG9ybmFkb1wiIH0sXG4gICAgICAgICAgICB7IGNvbnN0OiBcIlRzdW5hbWlcIiwgdGl0bGU6IFwiVHN1bmFtaVwiIH0sXG4gICAgICAgICAgICB7IGNvbnN0OiBcIlZvbGNhbmljIEFjdGl2aXR5XCIsIHRpdGxlOiBcIlZvbGNhbmljIEFjdGl2aXR5XCIgfSxcbiAgICAgICAgICBdLFxuICAgICAgICAgIHRpdGxlOiBcIlNlY29uZGFyeSB0eXBlIG9mIGRhbWFnZVwiLFxuICAgICAgICB9LFxuICAgICAgICBzdHJ1Y3R1cmVBY2Nlc3NpYmxlOiB7XG4gICAgICAgICAgdHlwZTogXCJzdHJpbmdcIixcbiAgICAgICAgICBvbmVPZjogW1xuICAgICAgICAgICAgeyBjb25zdDogXCJZZXNcIiwgdGl0bGU6IFwiWWVzXCIgfSxcbiAgICAgICAgICAgIHsgY29uc3Q6IFwiTm9cIiwgdGl0bGU6IFwiTm9cIiB9LFxuICAgICAgICAgICAgeyBjb25zdDogXCJVbmtub3duXCIsIHRpdGxlOiBcIlVua25vd25cIiB9LFxuICAgICAgICAgIF0sXG4gICAgICAgICAgdGl0bGU6IFwiSXMgdGhlIHN0cnVjdHVyZSBhY2Nlc3NpYmxlP1wiLFxuICAgICAgICB9LFxuICAgICAgICByZXNpZGVuY2VUeXBlOiB7XG4gICAgICAgICAgdHlwZTogW1wic3RyaW5nXCIsIFwibnVsbFwiXSxcbiAgICAgICAgICBvbmVPZjogW1xuICAgICAgICAgICAge1xuICAgICAgICAgICAgICBjb25zdDogXCJQcmltYXJ5IHJlc2lkZW5jZVwiLFxuICAgICAgICAgICAgICB0aXRsZTogXCJQcmltYXJ5IHJlc2lkZW5jZVwiLFxuICAgICAgICAgICAgfSxcbiAgICAgICAgICAgIHtcbiAgICAgICAgICAgICAgY29uc3Q6IFwiU2Vjb25kYXJ5IHJlc2lkZW5jZVwiLFxuICAgICAgICAgICAgICB0aXRsZTogXCJTZWNvbmRhcnkgcmVzaWRlbmNlXCIsXG4gICAgICAgICAgICB9LFxuICAgICAgICAgIF0sXG4gICAgICAgICAgdGl0bGU6IFwiUmVzaWRlbmNlIHR5cGVcIixcbiAgICAgICAgfSxcbiAgICAgIH0sXG4gICAgfSxcbiAgICB1aVNjaGVtYToge1xuICAgICAgXCJ1aTpvcmRlclwiOiBbXG4gICAgICAgIFwiYXNzZXNzbWVudERhdGVcIixcbiAgICAgICAgXCJldmVudE5hbWVcIixcbiAgICAgICAgXCJwcmltYXJ5RGFtYWdlVHlwZVwiLFxuICAgICAgICBcInNlY29uZGFyeURhbWFnZVR5cGVcIixcbiAgICAgICAgXCJ0ZXJ0aWFyeURhbWFnZVR5cGVcIixcbiAgICAgICAgXCJzdHJ1Y3R1cmVBY2Nlc3NpYmxlXCIsXG4gICAgICAgIFwic3RydWN0dXJlVXNlXCIsXG4gICAgICAgIFwic3RydWN0dXJlVHlwZVwiLFxuICAgICAgICBcImRhbWFnZURlZ3JlZVwiLFxuICAgICAgICBcIm93bmVyVHlwZVwiLFxuICAgICAgICBcInJlc2lkZW5jZVR5cGVcIixcbiAgICAgICAgXCJpbnN1cmFuY2VcIixcbiAgICAgICAgXCJzdHJ1Y3R1cmVGbG9vZGVkXCIsXG4gICAgICAgIFwiZGVwdGhPZkZsb29kaW5nXCIsXG4gICAgICAgIFwiZGVzY3JpcHRpb25cIixcbiAgICAgICAgXCJkb2N1bWVudFVwbG9hZHNcIixcbiAgICAgIF0sXG4gICAgICBcInVpOmhpZGVFcnJvclwiOiB0cnVlLFxuICAgICAgaW5zdXJhbmNlOiB7XG4gICAgICAgIG9uZU9mOiBbXG4gICAgICAgICAgeyBjb25zdDogXCJZZXNcIiwgdGl0bGU6IFwiWWVzXCIgfSxcbiAgICAgICAgICB7IGNvbnN0OiBcIk5vXCIsIHRpdGxlOiBcIk5vXCIgfSxcbiAgICAgICAgICB7IGNvbnN0OiBcIlVua25vd25cIiwgdGl0bGU6IFwiVW5rbm93blwiIH0sXG4gICAgICAgIF0sXG4gICAgICAgIFwidWk6bGFiZWxcIjogZmFsc2UsXG4gICAgICAgIFwidWk6d2lkZ2V0XCI6IFwic2VsZWN0XCIsXG4gICAgICAgIFwidWk6cGxhY2Vob2xkZXJcIjogXCJTZWxlY3QuLi5cIixcbiAgICAgICAgXCJ1aTpjYW5VcGRhdGVcIjogW1wiYWRtaW5cIiwgXCJtYW5hZ2VyXCIsIFwibWVtYmVyXCIsIFwiY3JlYXRvclwiXSxcbiAgICAgICAgXCJ1aTp2aWV3T25SZXRyaWV2ZVwiOiBbXG4gICAgICAgICAgXCJhZG1pblwiLFxuICAgICAgICAgIFwibWFuYWdlclwiLFxuICAgICAgICAgIFwibWVtYmVyXCIsXG4gICAgICAgICAgXCJjcmVhdG9yXCIsXG4gICAgICAgICAgXCJ2aWV3X29ubHlcIixcbiAgICAgICAgICBcImd1ZXN0XCIsXG4gICAgICAgIF0sXG4gICAgICAgIFwidWk6dmlld09uQ3JlYXRlXCI6IFtcImFkbWluXCIsIFwibWFuYWdlclwiLCBcIm1lbWJlclwiLCBcImNyZWF0b3JcIl0sXG4gICAgICB9LFxuICAgICAgb3duZXJUeXBlOiB7XG4gICAgICAgIG9uZU9mOiBbXG4gICAgICAgICAgeyBjb25zdDogXCJPd25lclwiLCB0aXRsZTogXCJPd25lclwiIH0sXG4gICAgICAgICAgeyBjb25zdDogXCJSZW50ZXJcIiwgdGl0bGU6IFwiUmVudGVyXCIgfSxcbiAgICAgICAgICB7IGNvbnN0OiBcIlVua25vd25cIiwgdGl0bGU6IFwiVW5rbm93blwiIH0sXG4gICAgICAgIF0sXG4gICAgICAgIFwidWk6bGFiZWxcIjogZmFsc2UsXG4gICAgICAgIFwidWk6d2lkZ2V0XCI6IFwic2VsZWN0XCIsXG4gICAgICAgIFwidWk6cGxhY2Vob2xkZXJcIjogXCJTZWxlY3QuLi5cIixcbiAgICAgICAgXCJ1aTpjYW5VcGRhdGVcIjogW1wiYWRtaW5cIiwgXCJtYW5hZ2VyXCIsIFwibWVtYmVyXCIsIFwiY3JlYXRvclwiXSxcbiAgICAgICAgXCJ1aTp2aWV3T25SZXRyaWV2ZVwiOiBbXG4gICAgICAgICAgXCJhZG1pblwiLFxuICAgICAgICAgIFwibWFuYWdlclwiLFxuICAgICAgICAgIFwibWVtYmVyXCIsXG4gICAgICAgICAgXCJjcmVhdG9yXCIsXG4gICAgICAgICAgXCJ2aWV3X29ubHlcIixcbiAgICAgICAgICBcImd1ZXN0XCIsXG4gICAgICAgIF0sXG4gICAgICAgIFwidWk6dmlld09uQ3JlYXRlXCI6IFtcImFkbWluXCIsIFwibWFuYWdlclwiLCBcIm1lbWJlclwiLCBcImNyZWF0b3JcIl0sXG4gICAgICB9LFxuICAgICAgZGVzY3JpcHRpb246IHtcbiAgICAgICAgXCJ1aTpsYWJlbFwiOiBmYWxzZSxcbiAgICAgICAgXCJ1aTp3aWRnZXRcIjogXCJ0ZXh0YXJlYVwiLFxuICAgICAgICBcInVpOnBsYWNlaG9sZGVyXCI6IFwiXCIsXG4gICAgICAgIFwidWk6Y2FuVXBkYXRlXCI6IFtcImFkbWluXCIsIFwibWFuYWdlclwiLCBcIm1lbWJlclwiLCBcImNyZWF0b3JcIl0sXG4gICAgICAgIFwidWk6dmlld09uUmV0cmlldmVcIjogW1xuICAgICAgICAgIFwiYWRtaW5cIixcbiAgICAgICAgICBcIm1hbmFnZXJcIixcbiAgICAgICAgICBcIm1lbWJlclwiLFxuICAgICAgICAgIFwiY3JlYXRvclwiLFxuICAgICAgICAgIFwidmlld19vbmx5XCIsXG4gICAgICAgICAgXCJndWVzdFwiLFxuICAgICAgICBdLFxuICAgICAgICBcInVpOnZpZXdPbkNyZWF0ZVwiOiBbXCJhZG1pblwiLCBcIm1hbmFnZXJcIiwgXCJtZW1iZXJcIiwgXCJjcmVhdG9yXCJdLFxuICAgICAgfSxcbiAgICAgIGRhbWFnZURlZ3JlZToge1xuICAgICAgICBcInVpOmxhYmVsXCI6IGZhbHNlLFxuICAgICAgICBcInVpOndpZGdldFwiOiBcIkRhbWFnZURlZ3JlZVwiLFxuICAgICAgICBcInVpOnBsYWNlaG9sZGVyXCI6IFwiU2VsZWN0Li4uXCIsXG4gICAgICAgIFwidWk6Y2FuVXBkYXRlXCI6IFtcImFkbWluXCIsIFwibWFuYWdlclwiLCBcIm1lbWJlclwiLCBcImNyZWF0b3JcIl0sXG4gICAgICAgIFwidWk6dmlld09uUmV0cmlldmVcIjogW1xuICAgICAgICAgIFwiYWRtaW5cIixcbiAgICAgICAgICBcIm1hbmFnZXJcIixcbiAgICAgICAgICBcIm1lbWJlclwiLFxuICAgICAgICAgIFwiY3JlYXRvclwiLFxuICAgICAgICAgIFwidmlld19vbmx5XCIsXG4gICAgICAgICAgXCJndWVzdFwiLFxuICAgICAgICBdLFxuICAgICAgICBcInVpOnZpZXdPbkNyZWF0ZVwiOiBbXCJhZG1pblwiLCBcIm1hbmFnZXJcIiwgXCJtZW1iZXJcIiwgXCJjcmVhdG9yXCJdLFxuICAgICAgfSxcbiAgICAgIHN0cnVjdHVyZVVzZToge1xuICAgICAgICBvbmVPZjogW1xuICAgICAgICAgIHsgY29uc3Q6IFwiQ29tbWVyY2lhbFwiLCB0aXRsZTogXCJDb21tZXJjaWFsXCIgfSxcbiAgICAgICAgICB7IGNvbnN0OiBcIlJlc2lkZW50aWFsXCIsIHRpdGxlOiBcIlJlc2lkZW50aWFsXCIgfSxcbiAgICAgICAgICB7IGNvbnN0OiBcIlB1YmxpY1wiLCB0aXRsZTogXCJQdWJsaWNcIiB9LFxuICAgICAgICAgIHsgY29uc3Q6IFwiVW5rbm93blwiLCB0aXRsZTogXCJVbmtub3duXCIgfSxcbiAgICAgICAgXSxcbiAgICAgICAgXCJ1aTpsYWJlbFwiOiBmYWxzZSxcbiAgICAgICAgXCJ1aTp3aWRnZXRcIjogXCJzZWxlY3RcIixcbiAgICAgICAgXCJ1aTpwbGFjZWhvbGRlclwiOiBcIlNlbGVjdC4uLlwiLFxuICAgICAgICBcInVpOmNhblVwZGF0ZVwiOiBbXCJhZG1pblwiLCBcIm1hbmFnZXJcIiwgXCJtZW1iZXJcIiwgXCJjcmVhdG9yXCJdLFxuICAgICAgICBcInVpOnZpZXdPblJldHJpZXZlXCI6IFtcbiAgICAgICAgICBcImFkbWluXCIsXG4gICAgICAgICAgXCJtYW5hZ2VyXCIsXG4gICAgICAgICAgXCJtZW1iZXJcIixcbiAgICAgICAgICBcImNyZWF0b3JcIixcbiAgICAgICAgICBcInZpZXdfb25seVwiLFxuICAgICAgICAgIFwiZ3Vlc3RcIixcbiAgICAgICAgXSxcbiAgICAgICAgXCJ1aTp2aWV3T25DcmVhdGVcIjogW1wiYWRtaW5cIiwgXCJtYW5hZ2VyXCIsIFwibWVtYmVyXCIsIFwiY3JlYXRvclwiXSxcbiAgICAgIH0sXG4gICAgICBzdHJ1Y3R1cmVUeXBlOiB7XG4gICAgICAgIG9uZU9mOiBbXG4gICAgICAgICAgeyBjb25zdDogXCJDb252ZW50aW9uYWxcIiwgdGl0bGU6IFwiQ29udmVudGlvbmFsXCIgfSxcbiAgICAgICAgICB7IGNvbnN0OiBcIk1hbnVmYWN0dXJlZFwiLCB0aXRsZTogXCJNYW51ZmFjdHVyZWRcIiB9LFxuICAgICAgICAgIHsgY29uc3Q6IFwiTW9iaWxlIGhvbWVcIiwgdGl0bGU6IFwiTW9iaWxlIGhvbWVcIiB9LFxuICAgICAgICAgIHsgY29uc3Q6IFwiTm9uLXN0YW5kYXJkXCIsIHRpdGxlOiBcIk5vbi1zdGFuZGFyZFwiIH0sXG4gICAgICAgICAgeyBjb25zdDogXCJVbmtub3duXCIsIHRpdGxlOiBcIlVua25vd25cIiB9LFxuICAgICAgICBdLFxuICAgICAgICBcInVpOmxhYmVsXCI6IGZhbHNlLFxuICAgICAgICBcInVpOndpZGdldFwiOiBcInNlbGVjdFwiLFxuICAgICAgICBcInVpOnBsYWNlaG9sZGVyXCI6IFwiU2VsZWN0Li4uXCIsXG4gICAgICAgIFwidWk6Y2FuVXBkYXRlXCI6IFtcImFkbWluXCIsIFwibWFuYWdlclwiLCBcIm1lbWJlclwiLCBcImNyZWF0b3JcIl0sXG4gICAgICAgIFwidWk6dmlld09uUmV0cmlldmVcIjogW1xuICAgICAgICAgIFwiYWRtaW5cIixcbiAgICAgICAgICBcIm1hbmFnZXJcIixcbiAgICAgICAgICBcIm1lbWJlclwiLFxuICAgICAgICAgIFwiY3JlYXRvclwiLFxuICAgICAgICAgIFwidmlld19vbmx5XCIsXG4gICAgICAgICAgXCJndWVzdFwiLFxuICAgICAgICBdLFxuICAgICAgICBcInVpOnZpZXdPbkNyZWF0ZVwiOiBbXCJhZG1pblwiLCBcIm1hbmFnZXJcIiwgXCJtZW1iZXJcIiwgXCJjcmVhdG9yXCJdLFxuICAgICAgfSxcbiAgICAgIGFzc2Vzc21lbnREYXRlOiB7XG4gICAgICAgIFwidWk6bGFiZWxcIjogZmFsc2UsXG4gICAgICAgIFwidWk6d2lkZ2V0XCI6IFwiZGF0ZVwiLFxuICAgICAgICBcInVpOmRlZmF1bHRUb1RvZGF5XCI6IHRydWUsXG4gICAgICAgIFwidWk6Y2FuVXBkYXRlXCI6IFtcImFkbWluXCIsIFwibWFuYWdlclwiLCBcIm1lbWJlclwiLCBcImNyZWF0b3JcIl0sXG4gICAgICAgIFwidWk6dmlld09uUmV0cmlldmVcIjogW1xuICAgICAgICAgIFwiYWRtaW5cIixcbiAgICAgICAgICBcIm1hbmFnZXJcIixcbiAgICAgICAgICBcIm1lbWJlclwiLFxuICAgICAgICAgIFwiY3JlYXRvclwiLFxuICAgICAgICAgIFwidmlld19vbmx5XCIsXG4gICAgICAgICAgXCJndWVzdFwiLFxuICAgICAgICBdLFxuICAgICAgICBcInVpOnZpZXdPbkNyZWF0ZVwiOiBbXCJhZG1pblwiLCBcIm1hbmFnZXJcIiwgXCJtZW1iZXJcIiwgXCJjcmVhdG9yXCJdLFxuICAgICAgfSxcbiAgICAgIGV2ZW50TmFtZToge1xuICAgICAgICBcInVpOmZpZWxkXCI6IFwibXVsdGlTZWxlY3RcIixcbiAgICAgICAgXCJ1aTpsYWJlbFwiOiBmYWxzZSxcbiAgICAgICAgXCJ1aTpjYW5VcGRhdGVcIjogW1wiY3JlYXRvclwiLCBcIm1lbWJlclwiLCBcIm1hbmFnZXJcIiwgXCJhZG1pblwiXSxcbiAgICAgICAgXCJ1aTpkZXNjcmlwdGlvblwiOiBcIlwiLFxuICAgICAgICBcInVpOnRvb2x0aXBUZXh0XCI6IFwiXCIsXG4gICAgICAgIFwidWk6dmlld09uQ3JlYXRlXCI6IFtcImFkbWluXCIsIFwibWFuYWdlclwiLCBcIm1lbWJlclwiLCBcImNyZWF0b3JcIl0sXG4gICAgICAgIFwidWk6dmlld09uUmV0cmlldmVcIjogW1xuICAgICAgICAgIFwidmlld19vbmx5XCIsXG4gICAgICAgICAgXCJjcmVhdG9yXCIsXG4gICAgICAgICAgXCJtZW1iZXJcIixcbiAgICAgICAgICBcIm1hbmFnZXJcIixcbiAgICAgICAgICBcImFkbWluXCIsXG4gICAgICAgIF0sXG4gICAgICB9LFxuICAgICAgZGVwdGhPZkZsb29kaW5nOiB7XG4gICAgICAgIFwidWk6c3RlcFwiOiAwLjUsXG4gICAgICAgIFwidWk6ZmllbGRcIjogXCJudW1iZXJcIixcbiAgICAgICAgXCJ1aTpsYWJlbFwiOiBmYWxzZSxcbiAgICAgICAgXCJ1aTpjYW5VcGRhdGVcIjogW1wiYWRtaW5cIiwgXCJtYW5hZ2VyXCIsIFwibWVtYmVyXCIsIFwiY3JlYXRvclwiXSxcbiAgICAgICAgXCJ1aTp2aWV3T25SZXRyaWV2ZVwiOiBbXG4gICAgICAgICAgXCJhZG1pblwiLFxuICAgICAgICAgIFwibWFuYWdlclwiLFxuICAgICAgICAgIFwibWVtYmVyXCIsXG4gICAgICAgICAgXCJjcmVhdG9yXCIsXG4gICAgICAgICAgXCJ2aWV3X29ubHlcIixcbiAgICAgICAgICBcImd1ZXN0XCIsXG4gICAgICAgIF0sXG4gICAgICAgIFwidWk6dmlld09uQ3JlYXRlXCI6IFtcImFkbWluXCIsIFwibWFuYWdlclwiLCBcIm1lbWJlclwiLCBcImNyZWF0b3JcIl0sXG4gICAgICB9LFxuICAgICAgZG9jdW1lbnRVcGxvYWRzOiB7XG4gICAgICAgIFwidWk6ZmllbGRcIjogXCJEb2N1bWVudFVwbG9hZGVyXCIsXG4gICAgICAgIFwidWk6bGFiZWxcIjogZmFsc2UsXG4gICAgICAgIFwidWk6ZG9jdW1lbnRUeXBlTmFtZVwiOiBcImltYWdlc1wiLFxuICAgICAgICBcInVpOmZpbGVTaXplRGVzY3JpcHRpb25cIjpcbiAgICAgICAgICBcIlRoZSBzaXplIGxpbWl0IGZvciBlYWNoIGluZGl2aWR1YWwgZmlsZSBpcyAzMCBNQi4gUGxlYXNlIHJlZHVjZSB0aGUgZmlsZSBzaXplIG9mIHlvdXIgaW1hZ2VzIGJlZm9yZSB1cGxvYWRpbmcgaWYgdGhleSBleGNlZWQgdGhpcyBsaW1pdC5cIixcbiAgICAgICAgXCJ1aTpmaWxlVHlwZURlc2NyaXB0aW9uXCI6XG4gICAgICAgICAgXCJXZSBvbmx5IGFsbG93IEpQRUcgYW5kIFBORyB1cGxvYWRzIGF0IHRoaXMgdGltZS4gSWYgeW91IGhhdmUgYW4gaW1hZ2Ugd2l0aCBhbm90aGVyIGZpbGUgdHlwZSwgcGxlYXNlIGNvbnZlcnQgaXQgdG8gSlBFRyBvciBQTkcgYmVmb3JlIHVwbG9hZGluZy5cIixcbiAgICAgICAgXCJ1aTpmaWxlUXVhbnRpdHlEZXNjcmlwdGlvblwiOlxuICAgICAgICAgIFwiWW91IGNhbiB1cGxvYWQgYXMgbWFueSBhcyAxMCBpbWFnZXMuIElmIHlvdSBoYXZlIGFkZGl0aW9uYWwgcHJvcGVydHkgaW1hZ2VzLCBwbGVhc2Ugc3RhcnQgYSBuZXcgaW5zcGVjdGlvbiBvciB1cGxvYWQgdG8gdGhlIHByb3BlcnR5LlwiLFxuICAgICAgICBcInVpOmRvY3VtZW50VHlwZUFiYnJldmlhdGlvblwiOiBcImltYWdlXCIsXG4gICAgICAgIFwidWk6Y2FuVXBkYXRlXCI6IFtcImFkbWluXCIsIFwibWFuYWdlclwiLCBcIm1lbWJlclwiLCBcImNyZWF0b3JcIl0sXG4gICAgICAgIFwidWk6dmlld09uUmV0cmlldmVcIjogW1xuICAgICAgICAgIFwiYWRtaW5cIixcbiAgICAgICAgICBcIm1hbmFnZXJcIixcbiAgICAgICAgICBcIm1lbWJlclwiLFxuICAgICAgICAgIFwiY3JlYXRvclwiLFxuICAgICAgICAgIFwidmlld19vbmx5XCIsXG4gICAgICAgICAgXCJndWVzdFwiLFxuICAgICAgICBdLFxuICAgICAgICBcInVpOnZpZXdPbkNyZWF0ZVwiOiBbXCJhZG1pblwiLCBcIm1hbmFnZXJcIiwgXCJtZW1iZXJcIiwgXCJjcmVhdG9yXCJdLFxuICAgICAgfSxcbiAgICAgIHN0cnVjdHVyZUZsb29kZWQ6IHtcbiAgICAgICAgb25lT2Y6IFtcbiAgICAgICAgICB7IGNvbnN0OiBcIlllc1wiLCB0aXRsZTogXCJZZXNcIiB9LFxuICAgICAgICAgIHsgY29uc3Q6IFwiTm9cIiwgdGl0bGU6IFwiTm9cIiB9LFxuICAgICAgICAgIHsgY29uc3Q6IFwiVW5rbm93blwiLCB0aXRsZTogXCJVbmtub3duXCIgfSxcbiAgICAgICAgXSxcbiAgICAgICAgXCJ1aTpsYWJlbFwiOiBmYWxzZSxcbiAgICAgICAgXCJ1aTp3aWRnZXRcIjogXCJzZWxlY3RcIixcbiAgICAgICAgXCJ1aTpwbGFjZWhvbGRlclwiOiBcIlNlbGVjdC4uLlwiLFxuICAgICAgICBcInVpOmNhblVwZGF0ZVwiOiBbXCJhZG1pblwiLCBcIm1hbmFnZXJcIiwgXCJtZW1iZXJcIiwgXCJjcmVhdG9yXCJdLFxuICAgICAgICBcInVpOnZpZXdPblJldHJpZXZlXCI6IFtcbiAgICAgICAgICBcImFkbWluXCIsXG4gICAgICAgICAgXCJtYW5hZ2VyXCIsXG4gICAgICAgICAgXCJtZW1iZXJcIixcbiAgICAgICAgICBcImNyZWF0b3JcIixcbiAgICAgICAgICBcInZpZXdfb25seVwiLFxuICAgICAgICAgIFwiZ3Vlc3RcIixcbiAgICAgICAgXSxcbiAgICAgICAgXCJ1aTp2aWV3T25DcmVhdGVcIjogW1wiYWRtaW5cIiwgXCJtYW5hZ2VyXCIsIFwibWVtYmVyXCIsIFwiY3JlYXRvclwiXSxcbiAgICAgIH0sXG4gICAgICBwcmltYXJ5RGFtYWdlVHlwZToge1xuICAgICAgICBvbmVPZjogW1xuICAgICAgICAgIHsgY29uc3Q6IFwiRmxvb2RpbmdcIiwgdGl0bGU6IFwiRmxvb2RpbmdcIiB9LFxuICAgICAgICAgIHsgY29uc3Q6IFwiRWFydGhxdWFrZVwiLCB0aXRsZTogXCJFYXJ0aHF1YWtlXCIgfSxcbiAgICAgICAgICB7IGNvbnN0OiBcIkhhaWxcIiwgdGl0bGU6IFwiSGFpbFwiIH0sXG4gICAgICAgICAgeyBjb25zdDogXCJXaW5kXCIsIHRpdGxlOiBcIldpbmRcIiB9LFxuICAgICAgICAgIHsgY29uc3Q6IFwiV2lsZGZpcmVcIiwgdGl0bGU6IFwiV2lsZGZpcmVcIiB9LFxuICAgICAgICAgIHtcbiAgICAgICAgICAgIGNvbnN0OiBcIldpbnRlciBXZWF0aGVyL0ljZSBTdG9ybVwiLFxuICAgICAgICAgICAgdGl0bGU6IFwiV2ludGVyIFdlYXRoZXIvSWNlIFN0b3JtXCIsXG4gICAgICAgICAgfSxcbiAgICAgICAgICB7IGNvbnN0OiBcIkxhbmRzbGlkZVwiLCB0aXRsZTogXCJMYW5kc2xpZGVcIiB9LFxuICAgICAgICAgIHsgY29uc3Q6IFwiTGlnaHRuaW5nXCIsIHRpdGxlOiBcIkxpZ2h0bmluZ1wiIH0sXG4gICAgICAgICAgeyBjb25zdDogXCJUb3JuYWRvXCIsIHRpdGxlOiBcIlRvcm5hZG9cIiB9LFxuICAgICAgICAgIHsgY29uc3Q6IFwiVHN1bmFtaVwiLCB0aXRsZTogXCJUc3VuYW1pXCIgfSxcbiAgICAgICAgICB7IGNvbnN0OiBcIlZvbGNhbmljIEFjdGl2aXR5XCIsIHRpdGxlOiBcIlZvbGNhbmljIEFjdGl2aXR5XCIgfSxcbiAgICAgICAgXSxcbiAgICAgICAgXCJ1aTpsYWJlbFwiOiBmYWxzZSxcbiAgICAgICAgXCJ1aTp3aWRnZXRcIjogXCJzZWxlY3RcIixcbiAgICAgICAgXCJ1aTpwbGFjZWhvbGRlclwiOiBcIlNlbGVjdC4uLlwiLFxuICAgICAgICBcInVpOmNhblVwZGF0ZVwiOiBbXCJhZG1pblwiLCBcIm1hbmFnZXJcIiwgXCJtZW1iZXJcIiwgXCJjcmVhdG9yXCJdLFxuICAgICAgICBcInVpOnZpZXdPblJldHJpZXZlXCI6IFtcbiAgICAgICAgICBcImFkbWluXCIsXG4gICAgICAgICAgXCJtYW5hZ2VyXCIsXG4gICAgICAgICAgXCJtZW1iZXJcIixcbiAgICAgICAgICBcImNyZWF0b3JcIixcbiAgICAgICAgICBcInZpZXdfb25seVwiLFxuICAgICAgICAgIFwiZ3Vlc3RcIixcbiAgICAgICAgXSxcbiAgICAgICAgXCJ1aTp2aWV3T25DcmVhdGVcIjogW1wiYWRtaW5cIiwgXCJtYW5hZ2VyXCIsIFwibWVtYmVyXCIsIFwiY3JlYXRvclwiXSxcbiAgICAgIH0sXG4gICAgICB0ZXJ0aWFyeURhbWFnZVR5cGU6IHtcbiAgICAgICAgb25lT2Y6IFtcbiAgICAgICAgICB7IGNvbnN0OiBcIkZsb29kaW5nXCIsIHRpdGxlOiBcIkZsb29kaW5nXCIgfSxcbiAgICAgICAgICB7IGNvbnN0OiBcIkVhcnRocXVha2VcIiwgdGl0bGU6IFwiRWFydGhxdWFrZVwiIH0sXG4gICAgICAgICAgeyBjb25zdDogXCJIYWlsXCIsIHRpdGxlOiBcIkhhaWxcIiB9LFxuICAgICAgICAgIHsgY29uc3Q6IFwiV2luZFwiLCB0aXRsZTogXCJXaW5kXCIgfSxcbiAgICAgICAgICB7IGNvbnN0OiBcIldpbGRmaXJlXCIsIHRpdGxlOiBcIldpbGRmaXJlXCIgfSxcbiAgICAgICAgICB7XG4gICAgICAgICAgICBjb25zdDogXCJXaW50ZXIgV2VhdGhlci9JY2UgU3Rvcm1cIixcbiAgICAgICAgICAgIHRpdGxlOiBcIldpbnRlciBXZWF0aGVyL0ljZSBTdG9ybVwiLFxuICAgICAgICAgIH0sXG4gICAgICAgICAgeyBjb25zdDogXCJMYW5kc2xpZGVcIiwgdGl0bGU6IFwiTGFuZHNsaWRlXCIgfSxcbiAgICAgICAgICB7IGNvbnN0OiBcIkxpZ2h0bmluZ1wiLCB0aXRsZTogXCJMaWdodG5pbmdcIiB9LFxuICAgICAgICAgIHsgY29uc3Q6IFwiVG9ybmFkb1wiLCB0aXRsZTogXCJUb3JuYWRvXCIgfSxcbiAgICAgICAgICB7IGNvbnN0OiBcIlRzdW5hbWlcIiwgdGl0bGU6IFwiVHN1bmFtaVwiIH0sXG4gICAgICAgICAgeyBjb25zdDogXCJWb2xjYW5pYyBBY3Rpdml0eVwiLCB0aXRsZTogXCJWb2xjYW5pYyBBY3Rpdml0eVwiIH0sXG4gICAgICAgIF0sXG4gICAgICAgIFwidWk6bGFiZWxcIjogZmFsc2UsXG4gICAgICAgIFwidWk6d2lkZ2V0XCI6IFwic2VsZWN0XCIsXG4gICAgICAgIFwidWk6cGxhY2Vob2xkZXJcIjogXCJTZWxlY3QuLi5cIixcbiAgICAgICAgXCJ1aTpjYW5VcGRhdGVcIjogW1wiYWRtaW5cIiwgXCJtYW5hZ2VyXCIsIFwibWVtYmVyXCIsIFwiY3JlYXRvclwiXSxcbiAgICAgICAgXCJ1aTp2aWV3T25SZXRyaWV2ZVwiOiBbXG4gICAgICAgICAgXCJhZG1pblwiLFxuICAgICAgICAgIFwibWFuYWdlclwiLFxuICAgICAgICAgIFwibWVtYmVyXCIsXG4gICAgICAgICAgXCJjcmVhdG9yXCIsXG4gICAgICAgICAgXCJ2aWV3X29ubHlcIixcbiAgICAgICAgICBcImd1ZXN0XCIsXG4gICAgICAgIF0sXG4gICAgICAgIFwidWk6dmlld09uQ3JlYXRlXCI6IFtcImFkbWluXCIsIFwibWFuYWdlclwiLCBcIm1lbWJlclwiLCBcImNyZWF0b3JcIl0sXG4gICAgICB9LFxuICAgICAgc2Vjb25kYXJ5RGFtYWdlVHlwZToge1xuICAgICAgICBvbmVPZjogW1xuICAgICAgICAgIHsgY29uc3Q6IFwiRmxvb2RpbmdcIiwgdGl0bGU6IFwiRmxvb2RpbmdcIiB9LFxuICAgICAgICAgIHsgY29uc3Q6IFwiRWFydGhxdWFrZVwiLCB0aXRsZTogXCJFYXJ0aHF1YWtlXCIgfSxcbiAgICAgICAgICB7IGNvbnN0OiBcIkhhaWxcIiwgdGl0bGU6IFwiSGFpbFwiIH0sXG4gICAgICAgICAgeyBjb25zdDogXCJXaW5kXCIsIHRpdGxlOiBcIldpbmRcIiB9LFxuICAgICAgICAgIHsgY29uc3Q6IFwiV2lsZGZpcmVcIiwgdGl0bGU6IFwiV2lsZGZpcmVcIiB9LFxuICAgICAgICAgIHtcbiAgICAgICAgICAgIGNvbnN0OiBcIldpbnRlciBXZWF0aGVyL0ljZSBTdG9ybVwiLFxuICAgICAgICAgICAgdGl0bGU6IFwiV2ludGVyIFdlYXRoZXIvSWNlIFN0b3JtXCIsXG4gICAgICAgICAgfSxcbiAgICAgICAgICB7IGNvbnN0OiBcIkxhbmRzbGlkZVwiLCB0aXRsZTogXCJMYW5kc2xpZGVcIiB9LFxuICAgICAgICAgIHsgY29uc3Q6IFwiTGlnaHRuaW5nXCIsIHRpdGxlOiBcIkxpZ2h0bmluZ1wiIH0sXG4gICAgICAgICAgeyBjb25zdDogXCJUb3JuYWRvXCIsIHRpdGxlOiBcIlRvcm5hZG9cIiB9LFxuICAgICAgICAgIHsgY29uc3Q6IFwiVHN1bmFtaVwiLCB0aXRsZTogXCJUc3VuYW1pXCIgfSxcbiAgICAgICAgICB7IGNvbnN0OiBcIlZvbGNhbmljIEFjdGl2aXR5XCIsIHRpdGxlOiBcIlZvbGNhbmljIEFjdGl2aXR5XCIgfSxcbiAgICAgICAgXSxcbiAgICAgICAgXCJ1aTpsYWJlbFwiOiBmYWxzZSxcbiAgICAgICAgXCJ1aTp3aWRnZXRcIjogXCJzZWxlY3RcIixcbiAgICAgICAgXCJ1aTpwbGFjZWhvbGRlclwiOiBcIlNlbGVjdC4uLlwiLFxuICAgICAgICBcInVpOmNhblVwZGF0ZVwiOiBbXCJhZG1pblwiLCBcIm1hbmFnZXJcIiwgXCJtZW1iZXJcIiwgXCJjcmVhdG9yXCJdLFxuICAgICAgICBcInVpOnZpZXdPblJldHJpZXZlXCI6IFtcbiAgICAgICAgICBcImFkbWluXCIsXG4gICAgICAgICAgXCJtYW5hZ2VyXCIsXG4gICAgICAgICAgXCJtZW1iZXJcIixcbiAgICAgICAgICBcImNyZWF0b3JcIixcbiAgICAgICAgICBcInZpZXdfb25seVwiLFxuICAgICAgICAgIFwiZ3Vlc3RcIixcbiAgICAgICAgXSxcbiAgICAgICAgXCJ1aTp2aWV3T25DcmVhdGVcIjogW1wiYWRtaW5cIiwgXCJtYW5hZ2VyXCIsIFwibWVtYmVyXCIsIFwiY3JlYXRvclwiXSxcbiAgICAgIH0sXG4gICAgICBzdHJ1Y3R1cmVBY2Nlc3NpYmxlOiB7XG4gICAgICAgIG9uZU9mOiBbXG4gICAgICAgICAgeyBjb25zdDogXCJZZXNcIiwgdGl0bGU6IFwiWWVzXCIgfSxcbiAgICAgICAgICB7IGNvbnN0OiBcIk5vXCIsIHRpdGxlOiBcIk5vXCIgfSxcbiAgICAgICAgICB7IGNvbnN0OiBcIlVua25vd25cIiwgdGl0bGU6IFwiVW5rbm93blwiIH0sXG4gICAgICAgIF0sXG4gICAgICAgIFwidWk6bGFiZWxcIjogZmFsc2UsXG4gICAgICAgIFwidWk6d2lkZ2V0XCI6IFwic2VsZWN0XCIsXG4gICAgICAgIFwidWk6cGxhY2Vob2xkZXJcIjogXCJTZWxlY3QuLi5cIixcbiAgICAgICAgXCJ1aTpjYW5VcGRhdGVcIjogW1wiYWRtaW5cIiwgXCJtYW5hZ2VyXCIsIFwibWVtYmVyXCIsIFwiY3JlYXRvclwiXSxcbiAgICAgICAgXCJ1aTp2aWV3T25SZXRyaWV2ZVwiOiBbXG4gICAgICAgICAgXCJhZG1pblwiLFxuICAgICAgICAgIFwibWFuYWdlclwiLFxuICAgICAgICAgIFwibWVtYmVyXCIsXG4gICAgICAgICAgXCJjcmVhdG9yXCIsXG4gICAgICAgICAgXCJ2aWV3X29ubHlcIixcbiAgICAgICAgICBcImd1ZXN0XCIsXG4gICAgICAgIF0sXG4gICAgICAgIFwidWk6dmlld09uQ3JlYXRlXCI6IFtcImFkbWluXCIsIFwibWFuYWdlclwiLCBcIm1lbWJlclwiLCBcImNyZWF0b3JcIl0sXG4gICAgICB9LFxuICAgICAgcmVzaWRlbmNlVHlwZToge1xuICAgICAgICBvbmVPZjogW1xuICAgICAgICAgIHtcbiAgICAgICAgICAgIGNvbnN0OiBcIlByaW1hcnkgcmVzaWRlbmNlXCIsXG4gICAgICAgICAgICB0aXRsZTogXCJQcmltYXJ5IHJlc2lkZW5jZVwiLFxuICAgICAgICAgIH0sXG4gICAgICAgICAge1xuICAgICAgICAgICAgY29uc3Q6IFwiU2Vjb25kYXJ5IHJlc2lkZW5jZVwiLFxuICAgICAgICAgICAgdGl0bGU6IFwiU2Vjb25kYXJ5IHJlc2lkZW5jZVwiLFxuICAgICAgICAgIH0sXG4gICAgICAgIF0sXG4gICAgICAgIFwidWk6bGFiZWxcIjogZmFsc2UsXG4gICAgICAgIFwidWk6d2lkZ2V0XCI6IFwic2VsZWN0XCIsXG4gICAgICAgIFwidWk6dXNlQXNUYWdcIjogZmFsc2UsXG4gICAgICAgIFwidWk6Y2FuVXBkYXRlXCI6IFtcImNyZWF0b3JcIiwgXCJtZW1iZXJcIiwgXCJtYW5hZ2VyXCIsIFwiYWRtaW5cIl0sXG4gICAgICAgIFwidWk6aGVscGVyVGV4dFwiOiBcIlwiLFxuICAgICAgICBcInVpOnBsYWNlaG9sZGVyXCI6IFwiXCIsXG4gICAgICAgIFwidWk6dG9vbHRpcFRleHRcIjogXCJcIixcbiAgICAgICAgXCJ1aTp2aWV3T25DcmVhdGVcIjogW1wiYWRtaW5cIiwgXCJtYW5hZ2VyXCIsIFwibWVtYmVyXCIsIFwiY3JlYXRvclwiXSxcbiAgICAgICAgXCJ1aTp2aWV3T25SZXRyaWV2ZVwiOiBbXG4gICAgICAgICAgXCJ2aWV3X29ubHlcIixcbiAgICAgICAgICBcImNyZWF0b3JcIixcbiAgICAgICAgICBcIm1lbWJlclwiLFxuICAgICAgICAgIFwibWFuYWdlclwiLFxuICAgICAgICAgIFwiYWRtaW5cIixcbiAgICAgICAgXSxcbiAgICAgIH0sXG4gICAgfSxcbiAgfSxcbn0gYXMgY29uc3Qgc2F0aXNmaWVzIENvbW1vbkZvcm1EZWZpbml0aW9uO1xuIl0sIm5hbWVzIjpbImluZGl2aWR1YWxBc3Npc3RhbmNlUHJlbGltaW5hcnlEYW1hZ2VBc3Nlc3NtZW50Rm9ybSIsIm5hbWUiLCJJQV9QREFfU1VCTUlTU0lPTl9UWVBFX05BTUUiLCJtb2R1bGVzIiwiU1VCTUlTU0lPTl9UWVBFX01PRFVMRSIsIlBSRUxJTUlOQVJZX0RBTUFHRV9BU1NFU1NNRU5UIiwiYXR0YWNobWVudHMiLCJ0eXBlIiwiT0JKRUNUX1RZUEUiLCJQUk9QRVJUWSIsInN1Y2Nlc3NNZXNzYWdlIiwicHJlYW1ibGUiLCJwb3N0YW1ibGUiLCJkZXNjcmlwdGlvbiIsImNhbkNyZWF0ZSIsIkNSRUFUT1JfQU5EX1VQIiwiY2FuQ3JlYXRlR3JvdXBzIiwiY2F0ZWdvcnkiLCJTVUJNSVNTSU9OX0NBVEVHT1JZIiwiSU5TUEVDVElPTlMiLCJmb3JtU3RydWN0dXJlIiwic2NoZW1hIiwicmVxdWlyZWQiLCJwcm9wZXJ0aWVzIiwiaW5zdXJhbmNlIiwib25lT2YiLCJjb25zdCIsInRpdGxlIiwib3duZXJUeXBlIiwiZGFtYWdlRGVncmVlIiwiZW51bSIsInN0cnVjdHVyZVVzZSIsInN0cnVjdHVyZVR5cGUiLCJhc3Nlc3NtZW50RGF0ZSIsImZvcm1hdCIsImV2ZW50TmFtZSIsIml0ZW1zIiwibWluSXRlbXMiLCJ1bmlxdWVJdGVtcyIsImRlcHRoT2ZGbG9vZGluZyIsImRvY3VtZW50VXBsb2FkcyIsImlkIiwiYWNjb3VudERvY3VtZW50VHlwZUlkIiwiUFJPUEVSVFlfSU1BR0VfQUNDT1VOVF9ET0NVTUVOVF9UWVBFX0lEIiwibWF4SXRlbXMiLCJzdHJ1Y3R1cmVGbG9vZGVkIiwicHJpbWFyeURhbWFnZVR5cGUiLCJ0ZXJ0aWFyeURhbWFnZVR5cGUiLCJzZWNvbmRhcnlEYW1hZ2VUeXBlIiwic3RydWN0dXJlQWNjZXNzaWJsZSIsInJlc2lkZW5jZVR5cGUiLCJ1aVNjaGVtYSJdLCJtYXBwaW5ncyI6Ijs7OzsrQkFZYUE7OztlQUFBQTs7OytCQVprQjsyQkFLeEI7NEJBSUE7QUFHQSxNQUFNQSxzREFBc0Q7SUFDakVDLE1BQU1DLHVDQUEyQjtJQUNqQ0MsU0FBUztRQUFDQyxpQ0FBc0IsQ0FBQ0MsNkJBQTZCO0tBQUM7SUFDL0RDLGFBQWE7UUFBQztZQUFFQyxNQUFNQyxzQkFBVyxDQUFDQyxRQUFRO1FBQUM7S0FBRTtJQUM3Q0MsZ0JBQWdCO0lBQ2hCQyxVQUFVO0lBQ1ZDLFdBQVc7SUFDWEMsYUFBYTtJQUNiQyxXQUFXQyw2QkFBYztJQUN6QkMsaUJBQWlCLEVBQUU7SUFDbkJDLFVBQVVDLDhCQUFtQixDQUFDQyxXQUFXO0lBQ3pDQyxlQUFlO1FBQ2JDLFFBQVE7WUFDTmQsTUFBTTtZQUNOZSxVQUFVO2dCQUNSO2dCQUNBO2dCQUNBO2dCQUNBO2dCQUNBO2dCQUNBO2dCQUNBO2dCQUNBO2FBQ0Q7WUFDREMsWUFBWTtnQkFDVkMsV0FBVztvQkFDVGpCLE1BQU07b0JBQ05rQixPQUFPO3dCQUNMOzRCQUFFQyxPQUFPOzRCQUFPQyxPQUFPO3dCQUFNO3dCQUM3Qjs0QkFBRUQsT0FBTzs0QkFBTUMsT0FBTzt3QkFBSzt3QkFDM0I7NEJBQUVELE9BQU87NEJBQVdDLE9BQU87d0JBQVU7cUJBQ3RDO29CQUNEQSxPQUFPO2dCQUNUO2dCQUNBQyxXQUFXO29CQUNUckIsTUFBTTtvQkFDTmtCLE9BQU87d0JBQ0w7NEJBQUVDLE9BQU87NEJBQVNDLE9BQU87d0JBQVE7d0JBQ2pDOzRCQUFFRCxPQUFPOzRCQUFVQyxPQUFPO3dCQUFTO3dCQUNuQzs0QkFBRUQsT0FBTzs0QkFBV0MsT0FBTzt3QkFBVTtxQkFDdEM7b0JBQ0RBLE9BQU87Z0JBQ1Q7Z0JBQ0FkLGFBQWE7b0JBQUVOLE1BQU07d0JBQUM7d0JBQVU7cUJBQU87b0JBQUVvQixPQUFPO2dCQUFjO2dCQUM5REUsY0FBYztvQkFDWkMsTUFBTTt3QkFBQzt3QkFBUTt3QkFBWTt3QkFBYTt3QkFBUzt3QkFBUztxQkFBVTtvQkFDcEV2QixNQUFNO29CQUNOb0IsT0FBTztnQkFDVDtnQkFDQUksY0FBYztvQkFDWnhCLE1BQU07b0JBQ05rQixPQUFPO3dCQUNMOzRCQUFFQyxPQUFPOzRCQUFjQyxPQUFPO3dCQUFhO3dCQUMzQzs0QkFBRUQsT0FBTzs0QkFBZUMsT0FBTzt3QkFBYzt3QkFDN0M7NEJBQUVELE9BQU87NEJBQVVDLE9BQU87d0JBQVM7d0JBQ25DOzRCQUFFRCxPQUFPOzRCQUFXQyxPQUFPO3dCQUFVO3FCQUN0QztvQkFDREEsT0FBTztnQkFDVDtnQkFDQUssZUFBZTtvQkFDYnpCLE1BQU07b0JBQ05rQixPQUFPO3dCQUNMOzRCQUFFQyxPQUFPOzRCQUFnQkMsT0FBTzt3QkFBZTt3QkFDL0M7NEJBQUVELE9BQU87NEJBQWdCQyxPQUFPO3dCQUFlO3dCQUMvQzs0QkFBRUQsT0FBTzs0QkFBZUMsT0FBTzt3QkFBYzt3QkFDN0M7NEJBQUVELE9BQU87NEJBQWdCQyxPQUFPO3dCQUFlO3dCQUMvQzs0QkFBRUQsT0FBTzs0QkFBV0MsT0FBTzt3QkFBVTtxQkFDdEM7b0JBQ0RBLE9BQU87Z0JBQ1Q7Z0JBQ0FNLGdCQUFnQjtvQkFDZDFCLE1BQU07b0JBQ05vQixPQUFPO29CQUNQTyxRQUFRO2dCQUNWO2dCQUNBQyxXQUFXO29CQUNUNUIsTUFBTTt3QkFBQzt3QkFBUztxQkFBTztvQkFDdkI2QixPQUFPO3dCQUNMN0IsTUFBTTt3QkFDTmtCLE9BQU87NEJBQUM7Z0NBQUVDLE9BQU87Z0NBQWdCQyxPQUFPOzRCQUFlO3lCQUFFO29CQUMzRDtvQkFDQUEsT0FBTztvQkFDUFUsVUFBVTtvQkFDVnhCLGFBQWE7b0JBQ2J5QixhQUFhO2dCQUNmO2dCQUNBQyxpQkFBaUI7b0JBQ2ZoQyxNQUFNO3dCQUFDO3dCQUFVO3FCQUFPO29CQUN4Qm9CLE9BQU87Z0JBQ1Q7Z0JBQ0FhLGlCQUFpQjtvQkFDZmpDLE1BQU07d0JBQUM7d0JBQVM7cUJBQU87b0JBQ3ZCNkIsT0FBTzt3QkFDTDdCLE1BQU07d0JBQ05nQixZQUFZOzRCQUNWa0IsSUFBSTtnQ0FBRWxDLE1BQU07b0NBQUM7b0NBQVU7aUNBQU87NEJBQUM7NEJBQy9CbUMsdUJBQXVCO2dDQUNyQlosTUFBTTtvQ0FBQ2EsbURBQXVDO2lDQUFDO2dDQUMvQ3BDLE1BQU07NEJBQ1I7d0JBQ0Y7b0JBQ0Y7b0JBQ0FvQixPQUFPO29CQUNQaUIsVUFBVTtvQkFDVlAsVUFBVTtnQkFDWjtnQkFDQVEsa0JBQWtCO29CQUNoQnRDLE1BQU07d0JBQUM7d0JBQVU7cUJBQU87b0JBQ3hCa0IsT0FBTzt3QkFDTDs0QkFBRUMsT0FBTzs0QkFBT0MsT0FBTzt3QkFBTTt3QkFDN0I7NEJBQUVELE9BQU87NEJBQU1DLE9BQU87d0JBQUs7d0JBQzNCOzRCQUFFRCxPQUFPOzRCQUFXQyxPQUFPO3dCQUFVO3FCQUN0QztvQkFDREEsT0FBTztnQkFDVDtnQkFDQW1CLG1CQUFtQjtvQkFDakJ2QyxNQUFNO29CQUNOa0IsT0FBTzt3QkFDTDs0QkFBRUMsT0FBTzs0QkFBWUMsT0FBTzt3QkFBVzt3QkFDdkM7NEJBQUVELE9BQU87NEJBQWNDLE9BQU87d0JBQWE7d0JBQzNDOzRCQUFFRCxPQUFPOzRCQUFRQyxPQUFPO3dCQUFPO3dCQUMvQjs0QkFBRUQsT0FBTzs0QkFBUUMsT0FBTzt3QkFBTzt3QkFDL0I7NEJBQUVELE9BQU87NEJBQVlDLE9BQU87d0JBQVc7d0JBQ3ZDOzRCQUNFRCxPQUFPOzRCQUNQQyxPQUFPO3dCQUNUO3dCQUNBOzRCQUFFRCxPQUFPOzRCQUFhQyxPQUFPO3dCQUFZO3dCQUN6Qzs0QkFBRUQsT0FBTzs0QkFBYUMsT0FBTzt3QkFBWTt3QkFDekM7NEJBQUVELE9BQU87NEJBQVdDLE9BQU87d0JBQVU7d0JBQ3JDOzRCQUFFRCxPQUFPOzRCQUFXQyxPQUFPO3dCQUFVO3dCQUNyQzs0QkFBRUQsT0FBTzs0QkFBcUJDLE9BQU87d0JBQW9CO3FCQUMxRDtvQkFDREEsT0FBTztnQkFDVDtnQkFDQW9CLG9CQUFvQjtvQkFDbEJ4QyxNQUFNO3dCQUFDO3dCQUFVO3FCQUFPO29CQUN4QmtCLE9BQU87d0JBQ0w7NEJBQUVDLE9BQU87NEJBQVlDLE9BQU87d0JBQVc7d0JBQ3ZDOzRCQUFFRCxPQUFPOzRCQUFjQyxPQUFPO3dCQUFhO3dCQUMzQzs0QkFBRUQsT0FBTzs0QkFBUUMsT0FBTzt3QkFBTzt3QkFDL0I7NEJBQUVELE9BQU87NEJBQVFDLE9BQU87d0JBQU87d0JBQy9COzRCQUFFRCxPQUFPOzRCQUFZQyxPQUFPO3dCQUFXO3dCQUN2Qzs0QkFDRUQsT0FBTzs0QkFDUEMsT0FBTzt3QkFDVDt3QkFDQTs0QkFBRUQsT0FBTzs0QkFBYUMsT0FBTzt3QkFBWTt3QkFDekM7NEJBQUVELE9BQU87NEJBQWFDLE9BQU87d0JBQVk7d0JBQ3pDOzRCQUFFRCxPQUFPOzRCQUFXQyxPQUFPO3dCQUFVO3dCQUNyQzs0QkFBRUQsT0FBTzs0QkFBV0MsT0FBTzt3QkFBVTt3QkFDckM7NEJBQUVELE9BQU87NEJBQXFCQyxPQUFPO3dCQUFvQjtxQkFDMUQ7b0JBQ0RBLE9BQU87Z0JBQ1Q7Z0JBQ0FxQixxQkFBcUI7b0JBQ25CekMsTUFBTTt3QkFBQzt3QkFBVTtxQkFBTztvQkFDeEJrQixPQUFPO3dCQUNMOzRCQUFFQyxPQUFPOzRCQUFZQyxPQUFPO3dCQUFXO3dCQUN2Qzs0QkFBRUQsT0FBTzs0QkFBY0MsT0FBTzt3QkFBYTt3QkFDM0M7NEJBQUVELE9BQU87NEJBQVFDLE9BQU87d0JBQU87d0JBQy9COzRCQUFFRCxPQUFPOzRCQUFRQyxPQUFPO3dCQUFPO3dCQUMvQjs0QkFBRUQsT0FBTzs0QkFBWUMsT0FBTzt3QkFBVzt3QkFDdkM7NEJBQ0VELE9BQU87NEJBQ1BDLE9BQU87d0JBQ1Q7d0JBQ0E7NEJBQUVELE9BQU87NEJBQWFDLE9BQU87d0JBQVk7d0JBQ3pDOzRCQUFFRCxPQUFPOzRCQUFhQyxPQUFPO3dCQUFZO3dCQUN6Qzs0QkFBRUQsT0FBTzs0QkFBV0MsT0FBTzt3QkFBVTt3QkFDckM7NEJBQUVELE9BQU87NEJBQVdDLE9BQU87d0JBQVU7d0JBQ3JDOzRCQUFFRCxPQUFPOzRCQUFxQkMsT0FBTzt3QkFBb0I7cUJBQzFEO29CQUNEQSxPQUFPO2dCQUNUO2dCQUNBc0IscUJBQXFCO29CQUNuQjFDLE1BQU07b0JBQ05rQixPQUFPO3dCQUNMOzRCQUFFQyxPQUFPOzRCQUFPQyxPQUFPO3dCQUFNO3dCQUM3Qjs0QkFBRUQsT0FBTzs0QkFBTUMsT0FBTzt3QkFBSzt3QkFDM0I7NEJBQUVELE9BQU87NEJBQVdDLE9BQU87d0JBQVU7cUJBQ3RDO29CQUNEQSxPQUFPO2dCQUNUO2dCQUNBdUIsZUFBZTtvQkFDYjNDLE1BQU07d0JBQUM7d0JBQVU7cUJBQU87b0JBQ3hCa0IsT0FBTzt3QkFDTDs0QkFDRUMsT0FBTzs0QkFDUEMsT0FBTzt3QkFDVDt3QkFDQTs0QkFDRUQsT0FBTzs0QkFDUEMsT0FBTzt3QkFDVDtxQkFDRDtvQkFDREEsT0FBTztnQkFDVDtZQUNGO1FBQ0Y7UUFDQXdCLFVBQVU7WUFDUixZQUFZO2dCQUNWO2dCQUNBO2dCQUNBO2dCQUNBO2dCQUNBO2dCQUNBO2dCQUNBO2dCQUNBO2dCQUNBO2dCQUNBO2dCQUNBO2dCQUNBO2dCQUNBO2dCQUNBO2dCQUNBO2dCQUNBO2FBQ0Q7WUFDRCxnQkFBZ0I7WUFDaEIzQixXQUFXO2dCQUNUQyxPQUFPO29CQUNMO3dCQUFFQyxPQUFPO3dCQUFPQyxPQUFPO29CQUFNO29CQUM3Qjt3QkFBRUQsT0FBTzt3QkFBTUMsT0FBTztvQkFBSztvQkFDM0I7d0JBQUVELE9BQU87d0JBQVdDLE9BQU87b0JBQVU7aUJBQ3RDO2dCQUNELFlBQVk7Z0JBQ1osYUFBYTtnQkFDYixrQkFBa0I7Z0JBQ2xCLGdCQUFnQjtvQkFBQztvQkFBUztvQkFBVztvQkFBVTtpQkFBVTtnQkFDekQscUJBQXFCO29CQUNuQjtvQkFDQTtvQkFDQTtvQkFDQTtvQkFDQTtvQkFDQTtpQkFDRDtnQkFDRCxtQkFBbUI7b0JBQUM7b0JBQVM7b0JBQVc7b0JBQVU7aUJBQVU7WUFDOUQ7WUFDQUMsV0FBVztnQkFDVEgsT0FBTztvQkFDTDt3QkFBRUMsT0FBTzt3QkFBU0MsT0FBTztvQkFBUTtvQkFDakM7d0JBQUVELE9BQU87d0JBQVVDLE9BQU87b0JBQVM7b0JBQ25DO3dCQUFFRCxPQUFPO3dCQUFXQyxPQUFPO29CQUFVO2lCQUN0QztnQkFDRCxZQUFZO2dCQUNaLGFBQWE7Z0JBQ2Isa0JBQWtCO2dCQUNsQixnQkFBZ0I7b0JBQUM7b0JBQVM7b0JBQVc7b0JBQVU7aUJBQVU7Z0JBQ3pELHFCQUFxQjtvQkFDbkI7b0JBQ0E7b0JBQ0E7b0JBQ0E7b0JBQ0E7b0JBQ0E7aUJBQ0Q7Z0JBQ0QsbUJBQW1CO29CQUFDO29CQUFTO29CQUFXO29CQUFVO2lCQUFVO1lBQzlEO1lBQ0FkLGFBQWE7Z0JBQ1gsWUFBWTtnQkFDWixhQUFhO2dCQUNiLGtCQUFrQjtnQkFDbEIsZ0JBQWdCO29CQUFDO29CQUFTO29CQUFXO29CQUFVO2lCQUFVO2dCQUN6RCxxQkFBcUI7b0JBQ25CO29CQUNBO29CQUNBO29CQUNBO29CQUNBO29CQUNBO2lCQUNEO2dCQUNELG1CQUFtQjtvQkFBQztvQkFBUztvQkFBVztvQkFBVTtpQkFBVTtZQUM5RDtZQUNBZ0IsY0FBYztnQkFDWixZQUFZO2dCQUNaLGFBQWE7Z0JBQ2Isa0JBQWtCO2dCQUNsQixnQkFBZ0I7b0JBQUM7b0JBQVM7b0JBQVc7b0JBQVU7aUJBQVU7Z0JBQ3pELHFCQUFxQjtvQkFDbkI7b0JBQ0E7b0JBQ0E7b0JBQ0E7b0JBQ0E7b0JBQ0E7aUJBQ0Q7Z0JBQ0QsbUJBQW1CO29CQUFDO29CQUFTO29CQUFXO29CQUFVO2lCQUFVO1lBQzlEO1lBQ0FFLGNBQWM7Z0JBQ1pOLE9BQU87b0JBQ0w7d0JBQUVDLE9BQU87d0JBQWNDLE9BQU87b0JBQWE7b0JBQzNDO3dCQUFFRCxPQUFPO3dCQUFlQyxPQUFPO29CQUFjO29CQUM3Qzt3QkFBRUQsT0FBTzt3QkFBVUMsT0FBTztvQkFBUztvQkFDbkM7d0JBQUVELE9BQU87d0JBQVdDLE9BQU87b0JBQVU7aUJBQ3RDO2dCQUNELFlBQVk7Z0JBQ1osYUFBYTtnQkFDYixrQkFBa0I7Z0JBQ2xCLGdCQUFnQjtvQkFBQztvQkFBUztvQkFBVztvQkFBVTtpQkFBVTtnQkFDekQscUJBQXFCO29CQUNuQjtvQkFDQTtvQkFDQTtvQkFDQTtvQkFDQTtvQkFDQTtpQkFDRDtnQkFDRCxtQkFBbUI7b0JBQUM7b0JBQVM7b0JBQVc7b0JBQVU7aUJBQVU7WUFDOUQ7WUFDQUssZUFBZTtnQkFDYlAsT0FBTztvQkFDTDt3QkFBRUMsT0FBTzt3QkFBZ0JDLE9BQU87b0JBQWU7b0JBQy9DO3dCQUFFRCxPQUFPO3dCQUFnQkMsT0FBTztvQkFBZTtvQkFDL0M7d0JBQUVELE9BQU87d0JBQWVDLE9BQU87b0JBQWM7b0JBQzdDO3dCQUFFRCxPQUFPO3dCQUFnQkMsT0FBTztvQkFBZTtvQkFDL0M7d0JBQUVELE9BQU87d0JBQVdDLE9BQU87b0JBQVU7aUJBQ3RDO2dCQUNELFlBQVk7Z0JBQ1osYUFBYTtnQkFDYixrQkFBa0I7Z0JBQ2xCLGdCQUFnQjtvQkFBQztvQkFBUztvQkFBVztvQkFBVTtpQkFBVTtnQkFDekQscUJBQXFCO29CQUNuQjtvQkFDQTtvQkFDQTtvQkFDQTtvQkFDQTtvQkFDQTtpQkFDRDtnQkFDRCxtQkFBbUI7b0JBQUM7b0JBQVM7b0JBQVc7b0JBQVU7aUJBQVU7WUFDOUQ7WUFDQU0sZ0JBQWdCO2dCQUNkLFlBQVk7Z0JBQ1osYUFBYTtnQkFDYixxQkFBcUI7Z0JBQ3JCLGdCQUFnQjtvQkFBQztvQkFBUztvQkFBVztvQkFBVTtpQkFBVTtnQkFDekQscUJBQXFCO29CQUNuQjtvQkFDQTtvQkFDQTtvQkFDQTtvQkFDQTtvQkFDQTtpQkFDRDtnQkFDRCxtQkFBbUI7b0JBQUM7b0JBQVM7b0JBQVc7b0JBQVU7aUJBQVU7WUFDOUQ7WUFDQUUsV0FBVztnQkFDVCxZQUFZO2dCQUNaLFlBQVk7Z0JBQ1osZ0JBQWdCO29CQUFDO29CQUFXO29CQUFVO29CQUFXO2lCQUFRO2dCQUN6RCxrQkFBa0I7Z0JBQ2xCLGtCQUFrQjtnQkFDbEIsbUJBQW1CO29CQUFDO29CQUFTO29CQUFXO29CQUFVO2lCQUFVO2dCQUM1RCxxQkFBcUI7b0JBQ25CO29CQUNBO29CQUNBO29CQUNBO29CQUNBO2lCQUNEO1lBQ0g7WUFDQUksaUJBQWlCO2dCQUNmLFdBQVc7Z0JBQ1gsWUFBWTtnQkFDWixZQUFZO2dCQUNaLGdCQUFnQjtvQkFBQztvQkFBUztvQkFBVztvQkFBVTtpQkFBVTtnQkFDekQscUJBQXFCO29CQUNuQjtvQkFDQTtvQkFDQTtvQkFDQTtvQkFDQTtvQkFDQTtpQkFDRDtnQkFDRCxtQkFBbUI7b0JBQUM7b0JBQVM7b0JBQVc7b0JBQVU7aUJBQVU7WUFDOUQ7WUFDQUMsaUJBQWlCO2dCQUNmLFlBQVk7Z0JBQ1osWUFBWTtnQkFDWix1QkFBdUI7Z0JBQ3ZCLDBCQUNFO2dCQUNGLDBCQUNFO2dCQUNGLDhCQUNFO2dCQUNGLCtCQUErQjtnQkFDL0IsZ0JBQWdCO29CQUFDO29CQUFTO29CQUFXO29CQUFVO2lCQUFVO2dCQUN6RCxxQkFBcUI7b0JBQ25CO29CQUNBO29CQUNBO29CQUNBO29CQUNBO29CQUNBO2lCQUNEO2dCQUNELG1CQUFtQjtvQkFBQztvQkFBUztvQkFBVztvQkFBVTtpQkFBVTtZQUM5RDtZQUNBSyxrQkFBa0I7Z0JBQ2hCcEIsT0FBTztvQkFDTDt3QkFBRUMsT0FBTzt3QkFBT0MsT0FBTztvQkFBTTtvQkFDN0I7d0JBQUVELE9BQU87d0JBQU1DLE9BQU87b0JBQUs7b0JBQzNCO3dCQUFFRCxPQUFPO3dCQUFXQyxPQUFPO29CQUFVO2lCQUN0QztnQkFDRCxZQUFZO2dCQUNaLGFBQWE7Z0JBQ2Isa0JBQWtCO2dCQUNsQixnQkFBZ0I7b0JBQUM7b0JBQVM7b0JBQVc7b0JBQVU7aUJBQVU7Z0JBQ3pELHFCQUFxQjtvQkFDbkI7b0JBQ0E7b0JBQ0E7b0JBQ0E7b0JBQ0E7b0JBQ0E7aUJBQ0Q7Z0JBQ0QsbUJBQW1CO29CQUFDO29CQUFTO29CQUFXO29CQUFVO2lCQUFVO1lBQzlEO1lBQ0FtQixtQkFBbUI7Z0JBQ2pCckIsT0FBTztvQkFDTDt3QkFBRUMsT0FBTzt3QkFBWUMsT0FBTztvQkFBVztvQkFDdkM7d0JBQUVELE9BQU87d0JBQWNDLE9BQU87b0JBQWE7b0JBQzNDO3dCQUFFRCxPQUFPO3dCQUFRQyxPQUFPO29CQUFPO29CQUMvQjt3QkFBRUQsT0FBTzt3QkFBUUMsT0FBTztvQkFBTztvQkFDL0I7d0JBQUVELE9BQU87d0JBQVlDLE9BQU87b0JBQVc7b0JBQ3ZDO3dCQUNFRCxPQUFPO3dCQUNQQyxPQUFPO29CQUNUO29CQUNBO3dCQUFFRCxPQUFPO3dCQUFhQyxPQUFPO29CQUFZO29CQUN6Qzt3QkFBRUQsT0FBTzt3QkFBYUMsT0FBTztvQkFBWTtvQkFDekM7d0JBQUVELE9BQU87d0JBQVdDLE9BQU87b0JBQVU7b0JBQ3JDO3dCQUFFRCxPQUFPO3dCQUFXQyxPQUFPO29CQUFVO29CQUNyQzt3QkFBRUQsT0FBTzt3QkFBcUJDLE9BQU87b0JBQW9CO2lCQUMxRDtnQkFDRCxZQUFZO2dCQUNaLGFBQWE7Z0JBQ2Isa0JBQWtCO2dCQUNsQixnQkFBZ0I7b0JBQUM7b0JBQVM7b0JBQVc7b0JBQVU7aUJBQVU7Z0JBQ3pELHFCQUFxQjtvQkFDbkI7b0JBQ0E7b0JBQ0E7b0JBQ0E7b0JBQ0E7b0JBQ0E7aUJBQ0Q7Z0JBQ0QsbUJBQW1CO29CQUFDO29CQUFTO29CQUFXO29CQUFVO2lCQUFVO1lBQzlEO1lBQ0FvQixvQkFBb0I7Z0JBQ2xCdEIsT0FBTztvQkFDTDt3QkFBRUMsT0FBTzt3QkFBWUMsT0FBTztvQkFBVztvQkFDdkM7d0JBQUVELE9BQU87d0JBQWNDLE9BQU87b0JBQWE7b0JBQzNDO3dCQUFFRCxPQUFPO3dCQUFRQyxPQUFPO29CQUFPO29CQUMvQjt3QkFBRUQsT0FBTzt3QkFBUUMsT0FBTztvQkFBTztvQkFDL0I7d0JBQUVELE9BQU87d0JBQVlDLE9BQU87b0JBQVc7b0JBQ3ZDO3dCQUNFRCxPQUFPO3dCQUNQQyxPQUFPO29CQUNUO29CQUNBO3dCQUFFRCxPQUFPO3dCQUFhQyxPQUFPO29CQUFZO29CQUN6Qzt3QkFBRUQsT0FBTzt3QkFBYUMsT0FBTztvQkFBWTtvQkFDekM7d0JBQUVELE9BQU87d0JBQVdDLE9BQU87b0JBQVU7b0JBQ3JDO3dCQUFFRCxPQUFPO3dCQUFXQyxPQUFPO29CQUFVO29CQUNyQzt3QkFBRUQsT0FBTzt3QkFBcUJDLE9BQU87b0JBQW9CO2lCQUMxRDtnQkFDRCxZQUFZO2dCQUNaLGFBQWE7Z0JBQ2Isa0JBQWtCO2dCQUNsQixnQkFBZ0I7b0JBQUM7b0JBQVM7b0JBQVc7b0JBQVU7aUJBQVU7Z0JBQ3pELHFCQUFxQjtvQkFDbkI7b0JBQ0E7b0JBQ0E7b0JBQ0E7b0JBQ0E7b0JBQ0E7aUJBQ0Q7Z0JBQ0QsbUJBQW1CO29CQUFDO29CQUFTO29CQUFXO29CQUFVO2lCQUFVO1lBQzlEO1lBQ0FxQixxQkFBcUI7Z0JBQ25CdkIsT0FBTztvQkFDTDt3QkFBRUMsT0FBTzt3QkFBWUMsT0FBTztvQkFBVztvQkFDdkM7d0JBQUVELE9BQU87d0JBQWNDLE9BQU87b0JBQWE7b0JBQzNDO3dCQUFFRCxPQUFPO3dCQUFRQyxPQUFPO29CQUFPO29CQUMvQjt3QkFBRUQsT0FBTzt3QkFBUUMsT0FBTztvQkFBTztvQkFDL0I7d0JBQUVELE9BQU87d0JBQVlDLE9BQU87b0JBQVc7b0JBQ3ZDO3dCQUNFRCxPQUFPO3dCQUNQQyxPQUFPO29CQUNUO29CQUNBO3dCQUFFRCxPQUFPO3dCQUFhQyxPQUFPO29CQUFZO29CQUN6Qzt3QkFBRUQsT0FBTzt3QkFBYUMsT0FBTztvQkFBWTtvQkFDekM7d0JBQUVELE9BQU87d0JBQVdDLE9BQU87b0JBQVU7b0JBQ3JDO3dCQUFFRCxPQUFPO3dCQUFXQyxPQUFPO29CQUFVO29CQUNyQzt3QkFBRUQsT0FBTzt3QkFBcUJDLE9BQU87b0JBQW9CO2lCQUMxRDtnQkFDRCxZQUFZO2dCQUNaLGFBQWE7Z0JBQ2Isa0JBQWtCO2dCQUNsQixnQkFBZ0I7b0JBQUM7b0JBQVM7b0JBQVc7b0JBQVU7aUJBQVU7Z0JBQ3pELHFCQUFxQjtvQkFDbkI7b0JBQ0E7b0JBQ0E7b0JBQ0E7b0JBQ0E7b0JBQ0E7aUJBQ0Q7Z0JBQ0QsbUJBQW1CO29CQUFDO29CQUFTO29CQUFXO29CQUFVO2lCQUFVO1lBQzlEO1lBQ0FzQixxQkFBcUI7Z0JBQ25CeEIsT0FBTztvQkFDTDt3QkFBRUMsT0FBTzt3QkFBT0MsT0FBTztvQkFBTTtvQkFDN0I7d0JBQUVELE9BQU87d0JBQU1DLE9BQU87b0JBQUs7b0JBQzNCO3dCQUFFRCxPQUFPO3dCQUFXQyxPQUFPO29CQUFVO2lCQUN0QztnQkFDRCxZQUFZO2dCQUNaLGFBQWE7Z0JBQ2Isa0JBQWtCO2dCQUNsQixnQkFBZ0I7b0JBQUM7b0JBQVM7b0JBQVc7b0JBQVU7aUJBQVU7Z0JBQ3pELHFCQUFxQjtvQkFDbkI7b0JBQ0E7b0JBQ0E7b0JBQ0E7b0JBQ0E7b0JBQ0E7aUJBQ0Q7Z0JBQ0QsbUJBQW1CO29CQUFDO29CQUFTO29CQUFXO29CQUFVO2lCQUFVO1lBQzlEO1lBQ0F1QixlQUFlO2dCQUNiekIsT0FBTztvQkFDTDt3QkFDRUMsT0FBTzt3QkFDUEMsT0FBTztvQkFDVDtvQkFDQTt3QkFDRUQsT0FBTzt3QkFDUEMsT0FBTztvQkFDVDtpQkFDRDtnQkFDRCxZQUFZO2dCQUNaLGFBQWE7Z0JBQ2IsZUFBZTtnQkFDZixnQkFBZ0I7b0JBQUM7b0JBQVc7b0JBQVU7b0JBQVc7aUJBQVE7Z0JBQ3pELGlCQUFpQjtnQkFDakIsa0JBQWtCO2dCQUNsQixrQkFBa0I7Z0JBQ2xCLG1CQUFtQjtvQkFBQztvQkFBUztvQkFBVztvQkFBVTtpQkFBVTtnQkFDNUQscUJBQXFCO29CQUNuQjtvQkFDQTtvQkFDQTtvQkFDQTtvQkFDQTtpQkFDRDtZQUNIO1FBQ0Y7SUFDRjtBQUNGIn0=